import React, { useState, useEffect, useRef, useCallback } from 'react';
import {
    Avatar,
    Box,
    Chip,
    TextField,
    Drawer,
    IconButton,
    Typography,
    Fade,
    Button,
    Alert,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    MenuItem,
    Checkbox,
    FormControlLabel,
    LinearProgress,
    CircularProgress,
    Menu,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText
} from '@mui/material';

import { makeStyles } from '@mui/styles';
import useTheme from '@mui/material/styles/useTheme';
import { IconSearch, IconTags, IconRefresh } from '@tabler/icons';
import { IconSparkles } from '@tabler/icons-react';

import EmojiEmotionsOutlinedIcon from '@mui/icons-material/EmojiEmotionsOutlined';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import SendIcon from '@mui/icons-material/Send';
import MicIcon from '@mui/icons-material/Mic';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
import DoneIcon from '@mui/icons-material/Done';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import ComputerOutlinedIcon from '@mui/icons-material/ComputerOutlined';
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import ForwardIcon from '@mui/icons-material/Forward';
import ReplyIcon from '@mui/icons-material/Reply';
import CloseIcon from '@mui/icons-material/Close';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DownloadIcon from '@mui/icons-material/Download';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PersonIcon from '@mui/icons-material/Person';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import AddIcon from '@mui/icons-material/Add';

import EmojiPicker from 'emoji-picker-react';

import { apiUrl, token } from '../../../../api';
import axios from 'axios';
import JanelaDadosContato from './JanelaDadosContato';
import NovaConversaDialog, { formatPhoneBR } from './NovaConversaDialog';

import DadosDeal from './DadosDealDrawer';

import { IconMenu2, IconArrowLeft } from '@tabler/icons';
import api from '../../../services/api';
import { encodePathSegments } from '../../../../utils/media-url';
import { styled } from '@mui/material/styles';
import useIsStandalone from '../../../../hooks/useIsStandalone';

// style constant
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex'
    },
    appBar: {
        backgroundColor: '#2B2C4A', //theme.palette.background.default,
        zIndex: theme.zIndex.drawer + 1,
        height: 48,
        transition: theme.transitions.create(['top'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        })
    },
    conversationBar: {
        background: '#161818',
        color: '#e60000'
    },
    toolbar: {
        minHeight: 48
    },
    appBarWidth: {
        transition: theme.transitions.create('width'),
        backgroundColor: theme.palette.background.default
    },
    content: {
        ...theme.typography.mainContent,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        [theme.breakpoints.up('md')]: {
            // marginLeft: -(drawerWidth - 20),
            // width: `calc(100% - ${drawerWidth}px)`
        },
        [theme.breakpoints.down('md')]: {
            marginLeft: '20px',
            // width: `calc(100% - ${drawerWidth}px)`,
            padding: '16px'
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '10px',
            // width: `calc(100% - ${drawerWidth}px)`,
            padding: '16px',
            marginRight: '10px'
        }
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        marginLeft: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        [theme.breakpoints.down('md')]: {
            marginLeft: '20px'
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '10px'
        }
    }
}));

function stringToColor(string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
}

function stringAvatar(name) {
    if (!name.includes(' ')) {
        return {
            sx: {
                bgcolor: stringToColor(name),
                color: '#FFFFFF'
            },
            children: `${name[0]}`
        };
    }
    return {
        sx: {
            bgcolor: stringToColor(name)
        },
        children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`
    };
}

function formatPhoneDisplay(phone) {
    const digits = String(phone || '').replace(/\D/g, '');
    if (!digits) return null;

    if (digits.length === 13) {
        // 55 + DDD (2) + numero (9)
        return `+${digits.slice(0, 2)} (${digits.slice(2, 4)}) ${digits.slice(4, 9)}-${digits.slice(9, 13)}`;
    }
    if (digits.length === 12) {
        // 55 + DDD (2) + numero (8)
        return `+${digits.slice(0, 2)} (${digits.slice(2, 4)}) ${digits.slice(4, 8)}-${digits.slice(8, 12)}`;
    }
    return `+${digits}`;
}

// Tique de enviado/entregue/lido, igual o WhatsApp - só faz sentido nas
// mensagens que a gente mandou (nunca nas do cliente).
function MessageStatusTicks({ status }) {
    if (status === 'read') {
        return <DoneAllIcon sx={{ fontSize: '0.95rem', color: '#53bdeb', verticalAlign: 'middle' }} />;
    }
    if (status === 'delivered') {
        return <DoneAllIcon sx={{ fontSize: '0.95rem', color: '#8696a0', verticalAlign: 'middle' }} />;
    }
    if (status === 'failed') {
        return null;
    }
    // 'sent' (ou qualquer outro valor) - só um tique
    return <DoneIcon sx={{ fontSize: '0.95rem', color: '#8696a0', verticalAlign: 'middle' }} />;
}

// Anexo (imagem/vídeo/áudio/documento) sem `media_url` - acontecia em
// branco, sem nenhum aviso, quando o download/upload do anexo falhava no
// recebimento (achado em produção: erros intermitentes de permissão no
// upload pro R2 pro Instagram/WhatsApp Oficial). `canRetry` só vem `true`
// quando o backend guardou o suficiente pra tentar de novo
// (`MessageContent.media_download_failed_info`, ver `message_retry_media`).
function MediaUnavailable({ filename, retrying, onRetry, canRetry }) {
    return (
        <Box>
            <Typography variant="body2" sx={{ color: 'text.secondary', fontStyle: 'italic', wordBreak: 'break-all' }}>
                📎 {filename || 'Anexo'} — não foi possível baixar
            </Typography>
            {canRetry && (
                <Button size="small" onClick={onRetry} disabled={retrying} sx={{ mt: 0.5, textTransform: 'none', p: 0, minWidth: 0 }}>
                    {retrying ? 'Tentando...' : 'Tentar novamente'}
                </Button>
            )}
        </Box>
    );
}

// Funções puras (sem fechar sobre estado do componente) - movidas pra
// escopo de módulo pra poderem ser usadas tanto por `JanelaConversa`
// quanto por `MessageList` (extraído abaixo pra não re-renderizar a lista
// inteira de mensagens a cada tecla digitada no campo de texto).
function formatConversationTimestamp(isoString) {
    const date = new Date(isoString);

    // sempre ajusta para o fuso de São Paulo, igual ao WhatsApp Web:
    // "Hoje às HH:mm" / "Ontem às HH:mm" / "dd/mm/aaaa às HH:mm".
    const options = { timeZone: 'America/Sao_Paulo' };
    const today = new Date().toLocaleDateString('pt-BR', options);
    const yesterday = new Date(Date.now() - 86400000).toLocaleDateString('pt-BR', options); // -1 dia
    const dateStr = date.toLocaleDateString('pt-BR', options);
    const hora = date.toLocaleTimeString('pt-BR', { ...options, hour: '2-digit', minute: '2-digit' });

    if (dateStr === today) {
        return `Hoje às ${hora}`;
    }
    if (dateStr === yesterday) {
        return `Ontem às ${hora}`;
    }
    return `${dateStr} às ${hora}`;
}

function getPrivateMediaUrl(path, appId) {
    if (!path || !appId) return '';
    const BACKEND_SERVER = process.env.REACT_APP_BACKEND_SERVER || 'http://127.0.0.1:8000/api/';
    return `${BACKEND_SERVER}v1/apps/${appId}/media/${encodePathSegments(path)}`;
}

// Mesma URL, mas pedindo pro backend forçar o download (Content-Disposition:
// attachment) em vez de só exibir a mídia inline - sem isso não dava pra
// salvar imagem/áudio/vídeo/documento de uma conversa no dispositivo.
function getPrivateMediaDownloadUrl(path, appId, filename) {
    return `${getPrivateMediaUrl(path, appId)}?download=1${filename ? `&filename=${encodeURIComponent(filename)}` : ''}`;
}

// Lista de mensagens de uma conversa - extraída de `JanelaConversa` e
// memoizada (`React.memo`) porque o campo de texto (`inputMessage`) vive
// no MESMO componente que essa lista: sem isolar a lista, cada tecla
// digitada re-renderizava a conversa inteira (centenas/milhares de
// balões, cada um com Box/IconButton/menus aninhados), causando o lag
// perceptível ao digitar relatado pelos usuários. Como `React.memo` só
// compara props por igualdade rasa, os handlers recebidos abaixo
// (`scrollToBottom`/`handleOpenMessageMenu`/`handleRetryMedia`) precisam
// ser estáveis entre renders (`useCallback` em `JanelaConversa`) - senão
// seriam sempre "novos" a cada render do pai e a memoização não teria
// efeito nenhum.
const MessageList = React.memo(function MessageList({
    mensagens,
    carregandoMensagens,
    isDark,
    appId,
    conversaTipo,
    isAtBottom,
    scrollToBottom,
    handleOpenMessageMenu,
    retriedMediaUrls,
    retryingMediaId,
    handleRetryMedia,
    setContatoParaSalvar,
    onContainerRef,
    hasMoreOlderMessages,
    loadingOlderMessages,
    onLoadOlderMessages
}) {
    return (
        <Box
            ref={onContainerRef}
            sx={{
                width: '100%',
                pl: 2,
                display: 'flex',
                flexDirection: 'column',
                backgroundImage: 'url(/background_wpp.png)'
            }}
            flex={1}
            overflow="auto"
            px={2}
            py={1}
        >
            {carregandoMensagens && mensagens.length === 0 ? (
                <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" flex={1} gap={1.5}>
                    <CircularProgress size={32} sx={{ color: '#00a884' }} />
                    <Typography variant="body2" sx={{ color: isDark ? '#aebac1' : '#54656f' }}>
                        Carregando mensagens...
                    </Typography>
                </Box>
            ) : (
                <>
                    {/* `message_list_create` (GET) agora só traz a janela mais
                        recente por padrão - esse botão busca história mais
                        antiga sob demanda em vez de sempre trazer tudo de uma
                        vez (achado de performance: conversas com meses de
                        histórico deixavam o poll de 3s pesado). */}
                    {hasMoreOlderMessages && onLoadOlderMessages && (
                        <Box display="flex" justifyContent="center" mb={1.5}>
                            <Button
                                size="small"
                                onClick={onLoadOlderMessages}
                                disabled={loadingOlderMessages}
                                sx={{ textTransform: 'none' }}
                            >
                                {loadingOlderMessages ? 'Carregando...' : 'Carregar mensagens anteriores'}
                            </Button>
                        </Box>
                    )}
                    {mensagens.map((msg) => {
                    const isAgent = msg.author.type === 'agent';
                    const isChatbot = msg.author.type === 'chatbot';
                    const isRightSide = isAgent || isChatbot;

                    const backgroundColor = isAgent
                        ? '#d9fdd3' // verde claro (agente)
                        : isChatbot
                          ? '#e3f2fd' // azul claro (chatbot)
                          : '#ffffff'; // branco (user)

                    return (
                        <Box key={msg.id} display="flex" justifyContent={isRightSide ? 'flex-end' : 'flex-start'} mb={1.2}>
                            {!isAtBottom && (
                                <Button
                                    onClick={() => scrollToBottom('smooth')}
                                    sx={{
                                        position: 'absolute',
                                        bottom: 80,
                                        right: 20
                                    }}
                                >
                                    <ExpandCircleDownIcon />
                                </Button>
                            )}
                            <Box
                                sx={{
                                    position: 'relative',
                                    maxWidth: '65%',
                                    pl: 1.5,
                                    pr: 3.5,
                                    py: 1,
                                    bgcolor: backgroundColor,
                                    borderRadius: isRightSide ? '8px 0px 8px 8px' : '0px 8px 8px 8px',
                                    boxShadow: '0 1px 1px rgba(0,0,0,0.1)',
                                    border: isChatbot ? '1px solid #90caf9' : 'none'
                                }}
                            >
                                <IconButton
                                    size="small"
                                    onClick={handleOpenMessageMenu(msg)}
                                    title="Opções da mensagem"
                                    sx={{
                                        position: 'absolute',
                                        top: 2,
                                        right: 2,
                                        p: 0.25,
                                        color: 'rgba(0,0,0,0.4)',
                                        '&:hover': { color: 'rgba(0,0,0,0.7)', bgcolor: 'rgba(0,0,0,0.06)' }
                                    }}
                                >
                                    <MoreVertIcon fontSize="small" />
                                </IconButton>

                                {isChatbot && (
                                    <Typography
                                        variant="caption"
                                        sx={{
                                            display: 'block',
                                            fontWeight: 600,
                                            fontSize: '0.65rem',
                                            color: '#1976d2',
                                            mb: 0.3
                                        }}
                                    >
                                        🤖 Chatbot
                                    </Typography>
                                )}

                                {msg.reply_to && (
                                    <Box
                                        sx={{
                                            borderLeft: '3px solid #06cf9c',
                                            bgcolor: 'rgba(0,0,0,0.04)',
                                            borderRadius: '4px',
                                            px: 1,
                                            py: 0.5,
                                            mb: 0.5
                                        }}
                                    >
                                        <Typography
                                            variant="caption"
                                            sx={{ display: 'block', fontWeight: 600, color: '#06cf9c' }}
                                        >
                                            {msg.reply_to.author_type === 'user' ? 'Cliente' : 'Você'}
                                        </Typography>
                                        {msg.reply_to.type === 'image' && msg.reply_to.media_url ? (
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                <img
                                                    src={getPrivateMediaUrl(msg.reply_to.media_url, appId)}
                                                    alt={msg.reply_to.media_filename || 'imagem'}
                                                    style={{ width: 32, height: 32, objectFit: 'cover', borderRadius: 4 }}
                                                />
                                                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                                    Imagem
                                                </Typography>
                                            </Box>
                                        ) : msg.reply_to.type === 'video' && msg.reply_to.media_url ? (
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                <VideocamOutlinedIcon fontSize="small" sx={{ color: 'text.secondary' }} />
                                                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                                    Vídeo
                                                </Typography>
                                            </Box>
                                        ) : msg.reply_to.type === 'audio' && msg.reply_to.media_url ? (
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                <MicIcon fontSize="small" sx={{ color: 'text.secondary' }} />
                                                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                                    Áudio
                                                </Typography>
                                            </Box>
                                        ) : (msg.reply_to.type === 'document' || msg.reply_to.type === 'file') && msg.reply_to.media_url ? (
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                <DescriptionOutlinedIcon fontSize="small" sx={{ color: 'text.secondary' }} />
                                                <Typography
                                                    variant="caption"
                                                    sx={{
                                                        display: '-webkit-box',
                                                        WebkitLineClamp: 1,
                                                        WebkitBoxOrient: 'vertical',
                                                        overflow: 'hidden',
                                                        color: 'text.secondary'
                                                    }}
                                                >
                                                    {msg.reply_to.media_filename || 'Arquivo'}
                                                </Typography>
                                            </Box>
                                        ) : (
                                            <Typography
                                                variant="caption"
                                                sx={{
                                                    display: '-webkit-box',
                                                    WebkitLineClamp: 2,
                                                    WebkitBoxOrient: 'vertical',
                                                    overflow: 'hidden',
                                                    color: 'text.secondary'
                                                }}
                                            >
                                                {msg.reply_to.text || 'Mensagem'}
                                            </Typography>
                                        )}
                                    </Box>
                                )}

                                {conversaTipo === 'email' &&
                                    (msg.content.email_to?.length > 0 || msg.content.email_cc?.length > 0) && (
                                        <Box
                                            sx={{
                                                bgcolor: 'rgba(0,0,0,0.04)',
                                                borderRadius: '4px',
                                                px: 1,
                                                py: 0.5,
                                                mb: 0.5
                                            }}
                                        >
                                            {msg.content.email_to?.length > 0 && (
                                                <Typography variant="caption" sx={{ display: 'block', color: 'text.secondary' }}>
                                                    <b>Para:</b>{' '}
                                                    {msg.content.email_to.map((d) => d.name || d.email).join(', ')}
                                                </Typography>
                                            )}
                                            {msg.content.email_cc?.length > 0 && (
                                                <Typography variant="caption" sx={{ display: 'block', color: 'text.secondary' }}>
                                                    <b>Cc:</b> {msg.content.email_cc.map((d) => d.name || d.email).join(', ')}
                                                </Typography>
                                            )}
                                        </Box>
                                    )}

                                {msg.content.type === 'image' &&
                                    (() => {
                                        const mediaUrl = msg.content.media_url || retriedMediaUrls[msg.id];
                                        if (!mediaUrl) {
                                            return (
                                                <MediaUnavailable
                                                    filename={msg.content.media_filename || 'Imagem'}
                                                    retrying={retryingMediaId === msg.id}
                                                    onRetry={() => handleRetryMedia(msg)}
                                                    canRetry={msg.content.media_download_pending}
                                                />
                                            );
                                        }
                                        return (
                                            <Box sx={{ position: 'relative' }}>
                                                <img
                                                    src={getPrivateMediaUrl(mediaUrl, appId)}
                                                    alt={msg.content.media_filename || 'imagem'}
                                                    style={{ maxWidth: '100%', borderRadius: 6, display: 'block' }}
                                                />
                                                <IconButton
                                                    component="a"
                                                    href={getPrivateMediaDownloadUrl(mediaUrl, appId, msg.content.media_filename || 'imagem.jpg')}
                                                    download={msg.content.media_filename || 'imagem.jpg'}
                                                    size="small"
                                                    title="Baixar imagem"
                                                    sx={{
                                                        position: 'absolute',
                                                        top: 4,
                                                        right: 4,
                                                        bgcolor: 'rgba(0,0,0,0.5)',
                                                        color: '#fff',
                                                        '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' }
                                                    }}
                                                >
                                                    <DownloadIcon fontSize="small" />
                                                </IconButton>
                                                {msg.content.text && (
                                                    <Typography
                                                        variant="body2"
                                                        sx={{ mt: 0.5, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
                                                    >
                                                        {msg.content.text}
                                                    </Typography>
                                                )}
                                            </Box>
                                        );
                                    })()}

                                {msg.content.type === 'video' &&
                                    (() => {
                                        const mediaUrl = msg.content.media_url || retriedMediaUrls[msg.id];
                                        if (!mediaUrl) {
                                            return (
                                                <MediaUnavailable
                                                    filename={msg.content.media_filename || 'Vídeo'}
                                                    retrying={retryingMediaId === msg.id}
                                                    onRetry={() => handleRetryMedia(msg)}
                                                    canRetry={msg.content.media_download_pending}
                                                />
                                            );
                                        }
                                        return (
                                            <Box sx={{ position: 'relative' }}>
                                                <video
                                                    controls
                                                    src={getPrivateMediaUrl(mediaUrl, appId)}
                                                    style={{ maxWidth: '100%', borderRadius: 6, display: 'block' }}
                                                />
                                                <IconButton
                                                    component="a"
                                                    href={getPrivateMediaDownloadUrl(mediaUrl, appId, msg.content.media_filename || 'video.mp4')}
                                                    download={msg.content.media_filename || 'video.mp4'}
                                                    size="small"
                                                    title="Baixar vídeo"
                                                    sx={{
                                                        position: 'absolute',
                                                        top: 4,
                                                        right: 4,
                                                        bgcolor: 'rgba(0,0,0,0.5)',
                                                        color: '#fff',
                                                        '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' }
                                                    }}
                                                >
                                                    <DownloadIcon fontSize="small" />
                                                </IconButton>
                                                {msg.content.text && (
                                                    <Typography
                                                        variant="body2"
                                                        sx={{ mt: 0.5, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
                                                    >
                                                        {msg.content.text}
                                                    </Typography>
                                                )}
                                            </Box>
                                        );
                                    })()}

                                {msg.content.type === 'audio' &&
                                    (() => {
                                        const mediaUrl = msg.content.media_url || retriedMediaUrls[msg.id];
                                        if (!mediaUrl) {
                                            return (
                                                <MediaUnavailable
                                                    filename={msg.content.media_filename || 'Áudio'}
                                                    retrying={retryingMediaId === msg.id}
                                                    onRetry={() => handleRetryMedia(msg)}
                                                    canRetry={msg.content.media_download_pending}
                                                />
                                            );
                                        }
                                        return (
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                <audio controls style={{ maxWidth: '100%' }}>
                                                    <source
                                                        src={getPrivateMediaUrl(mediaUrl, appId)}
                                                        type={msg.content.media_mime_type || 'audio/webm'}
                                                    />
                                                </audio>
                                                <IconButton
                                                    component="a"
                                                    href={getPrivateMediaDownloadUrl(mediaUrl, appId, msg.content.media_filename || 'audio.ogg')}
                                                    download={msg.content.media_filename || 'audio.ogg'}
                                                    size="small"
                                                    title="Baixar áudio"
                                                >
                                                    <DownloadIcon fontSize="small" />
                                                </IconButton>
                                            </Box>
                                        );
                                    })()}

                                {(msg.content.type === 'document' || msg.content.type === 'file') &&
                                    (() => {
                                        const mediaUrl = msg.content.media_url || retriedMediaUrls[msg.id];
                                        if (mediaUrl) {
                                            return (
                                                <Box>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                        <a
                                                            href={getPrivateMediaDownloadUrl(mediaUrl, appId, msg.content.media_filename)}
                                                            download={msg.content.media_filename || 'arquivo'}
                                                            style={{
                                                                color: '#1976d2',
                                                                textDecoration: 'underline',
                                                                wordBreak: 'break-all'
                                                            }}
                                                        >
                                                            {msg.content.media_filename || 'Arquivo'}
                                                        </a>
                                                        <IconButton
                                                            component="a"
                                                            href={getPrivateMediaDownloadUrl(mediaUrl, appId, msg.content.media_filename)}
                                                            download={msg.content.media_filename || 'arquivo'}
                                                            size="small"
                                                            title="Baixar arquivo"
                                                        >
                                                            <DownloadIcon fontSize="small" />
                                                        </IconButton>
                                                    </Box>
                                                    {msg.content.text && (
                                                        <Typography
                                                            variant="body2"
                                                            sx={{ mt: 0.5, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
                                                        >
                                                            {msg.content.text}
                                                        </Typography>
                                                    )}
                                                </Box>
                                            );
                                        }

                                        // media_url nulo - o download/upload falhou no recebimento
                                        // (ver `conversas/webhooks/views.py::handle_received_message`).
                                        // Antes disso não mostrava NADA aqui; agora pelo menos avisa,
                                        // e só oferece "Tentar novamente" quando o backend guardou o
                                        // suficiente pra isso ser possível (`media_download_pending`).
                                        return (
                                            <MediaUnavailable
                                                filename={msg.content.media_filename}
                                                retrying={retryingMediaId === msg.id}
                                                onRetry={() => handleRetryMedia(msg)}
                                                canRetry={msg.content.media_download_pending}
                                            />
                                        );
                                    })()}

                                {msg.content.type === 'interactive' && msg.content.interactive_payload && (
                                    <Box>
                                        <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                            {msg.content.interactive_payload.body_text}
                                        </Typography>
                                        {msg.content.interactive_payload.kind === 'buttons' && (
                                            <Box sx={{ mt: 1 }}>
                                                {(msg.content.interactive_payload.buttons || []).map((btn, i) => (
                                                    <Box
                                                        key={i}
                                                        sx={{
                                                            border: '1px solid rgba(0,0,0,0.15)',
                                                            borderRadius: '8px',
                                                            textAlign: 'center',
                                                            color: '#0091ea',
                                                            py: 0.5,
                                                            mt: 0.5
                                                        }}
                                                    >
                                                        <Typography variant="body2">{btn.title || btn.buttonText}</Typography>
                                                    </Box>
                                                ))}
                                            </Box>
                                        )}
                                        {msg.content.interactive_payload.kind === 'list' && (
                                            <Box
                                                sx={{
                                                    border: '1px solid rgba(0,0,0,0.15)',
                                                    borderRadius: '8px',
                                                    mt: 1,
                                                    p: 1
                                                }}
                                            >
                                                <Typography variant="body2" sx={{ color: '#0091ea', mb: 0.5 }}>
                                                    {msg.content.interactive_payload.button_text || 'Ver opções'}
                                                </Typography>
                                                {(msg.content.interactive_payload.sections || []).map((section, si) => (
                                                    <Box key={si} sx={{ mt: 0.5 }}>
                                                        <Typography variant="caption" color="text.secondary" fontWeight="700">
                                                            {section.title}
                                                        </Typography>
                                                        {(section.rows || []).map((row, ri) => (
                                                            <Typography key={ri} variant="body2" sx={{ pl: 1 }}>
                                                                • {row.title}
                                                            </Typography>
                                                        ))}
                                                    </Box>
                                                ))}
                                            </Box>
                                        )}
                                    </Box>
                                )}

                                {msg.content.type === 'contact' && msg.content.contact_payload && (
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 180 }}>
                                        <Box
                                            sx={{
                                                width: 38,
                                                height: 38,
                                                borderRadius: '50%',
                                                bgcolor: 'rgba(0,0,0,0.08)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                flexShrink: 0
                                            }}
                                        >
                                            <PersonIcon sx={{ color: 'rgba(0,0,0,0.5)' }} />
                                        </Box>
                                        <Box flex={1} minWidth={0}>
                                            <Typography variant="body2" fontWeight={600} sx={{ wordBreak: 'break-word' }}>
                                                {msg.content.contact_payload.name}
                                            </Typography>
                                            {msg.content.contact_payload.phone && (
                                                <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block' }}>
                                                    {formatPhoneDisplay(msg.content.contact_payload.phone)}
                                                </Typography>
                                            )}
                                            <Button
                                                size="small"
                                                startIcon={<PersonAddAlt1Icon fontSize="small" />}
                                                onClick={() =>
                                                    setContatoParaSalvar({
                                                        nome: msg.content.contact_payload.name || '',
                                                        telefone: msg.content.contact_payload.phone || ''
                                                    })
                                                }
                                                sx={{ textTransform: 'none', p: 0, minWidth: 0, mt: 0.5 }}
                                            >
                                                Salvar contato
                                            </Button>
                                        </Box>
                                    </Box>
                                )}

                                {(msg.content.type === 'text' || !msg.content.type) && (
                                    <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                        {msg.content.text}
                                    </Typography>
                                )}

                                {/* Botões de um Template (WhatsApp) mandado com imagem/texto -
                                    independente de `type` (ele já é 'image'/'text', não
                                    'interactive') porque o header/corpo E os botões fazem parte
                                    da MESMA mensagem de template. O bloco `type === 'interactive'`
                                    acima é o de `WhatsappInteractiveTemplate` (lista/botões como
                                    mensagem própria, sem imagem) - por isso o guard abaixo evita
                                    renderizar os botões duas vezes pra esse caso. */}
                                {msg.content.type !== 'interactive' &&
                                    msg.content.interactive_payload?.kind === 'buttons' && (
                                        <Box sx={{ mt: 1 }}>
                                            {(msg.content.interactive_payload.buttons || []).map((btn, i) => (
                                                <Box
                                                    key={i}
                                                    sx={{
                                                        border: '1px solid rgba(0,0,0,0.15)',
                                                        borderRadius: '8px',
                                                        textAlign: 'center',
                                                        color: '#0091ea',
                                                        py: 0.5,
                                                        mt: 0.5
                                                    }}
                                                >
                                                    <Typography variant="body2">
                                                        {btn.text || btn.buttonText || btn.title}
                                                    </Typography>
                                                </Box>
                                            ))}
                                        </Box>
                                    )}

                                <Typography
                                    variant="caption"
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        alignItems: 'center',
                                        gap: 0.4,
                                        mt: 0.5,
                                        fontSize: '0.7rem',
                                        color: 'text.secondary'
                                    }}
                                >
                                    {formatConversationTimestamp(msg.received)}
                                    {isRightSide && <MessageStatusTicks status={msg.status} />}
                                </Typography>

                                {msg.reaction_emoji && (
                                    <Box
                                        sx={{
                                            position: 'absolute',
                                            bottom: -10,
                                            [isRightSide ? 'left' : 'right']: -6,
                                            bgcolor: '#fff',
                                            borderRadius: '50%',
                                            width: 22,
                                            height: 22,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: '0.85rem',
                                            boxShadow: '0 1px 2px rgba(0,0,0,0.25)'
                                        }}
                                    >
                                        {msg.reaction_emoji}
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    );
                    })}
                </>
            )}
        </Box>
    );
});

const JanelaConversa = ({
    status_drawer,
    onCloseDrawer,
    conversa_selecionada,
    mensagens,
    carregandoMensagens,
    appId,
    conversa_lida,
    deal,
    onDealChange,
    onDealsChanged,
    onConversationUpdate,
    pipelineId,
    integration_id,
    hasMoreOlderMessages,
    loadingOlderMessages,
    onLoadOlderMessages
}) => {
    const isStandalone = useIsStandalone();

    const [showEmoji, setShowEmoji] = useState(false);

    // Progresso de upload de anexo (arquivo/imagem/áudio/vídeo) - mostra
    // barra + % enquanto sobe, igual o WhatsApp faz, em vez de deixar a
    // tela parada sem nenhum feedback até a requisição terminar.
    const [uploadingFile, setUploadingFile] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploadFileName, setUploadFileName] = useState('');
    const [uploadError, setUploadError] = useState('');

    // Anexo que falhou no recebimento (w-api) e ficou com media_url nulo -
    // "media_download_pending" (vindo do backend) diz se ainda dá pra
    // tentar de novo. `retriedMediaUrls` guarda o resultado de um retry
    // que deu certo AGORA (sem precisar esperar o próximo poll de
    // `mensagens`, que é uma prop vinda do componente pai, pra atualizar a
    // bolha na hora).
    const [retryingMediaId, setRetryingMediaId] = useState(null);
    const [retriedMediaUrls, setRetriedMediaUrls] = useState({});

    // `useCallback` (não função solta) - essa função vira PROP de
    // `MessageList` (memoizado): sem identidade estável entre renders, a
    // memoização não teria efeito (toda tecla digitada recriaria essa
    // função, o que por si só já invalidaria o memo).
    const handleRetryMedia = useCallback(
        async (msg) => {
            setRetryingMediaId(msg.id);
            try {
                const res = await api.post(`v1/apps/${appId}/conversations/${conversa_selecionada.id}/messages/${msg.id}/retry_media/`);
                setRetriedMediaUrls((prev) => ({ ...prev, [msg.id]: res.data.media_url }));
            } catch (err) {
                alert(err.response?.data?.error || 'Erro ao tentar baixar o anexo de novo.');
            } finally {
                setRetryingMediaId(null);
            }
        },
        [appId, conversa_selecionada?.id]
    );

    // Menu do clipe (arquivo do computador x documento já cadastrado na
    // biblioteca de Documentos) + dialog de seleção de documento existente.
    const [attachMenuAnchor, setAttachMenuAnchor] = useState(null);
    const [documentPickerOpen, setDocumentPickerOpen] = useState(false);
    const [documentFolders, setDocumentFolders] = useState([]);
    const [documentPickerFolderId, setDocumentPickerFolderId] = useState(null);
    const [documentPickerDocuments, setDocumentPickerDocuments] = useState([]);
    const [documentPickerLoading, setDocumentPickerLoading] = useState(false);

    // Botão "..." no canto de cada mensagem mostra um menu com "Responder" e
    // "Encaminhar" - "Responder" só guarda a mensagem numa barra de citação
    // acima do input (sem dialog); "Encaminhar" abre o dialog de seleção de
    // conversas de destino. Era um "clicar e segurar" na mensagem inteira,
    // mas isso exigia `userSelect: none` no balão pra não abrir o menu à
    // toa numa seleção de texto - o que também impedia copiar o texto da
    // mensagem. Um botão dedicado resolve os dois: menu continua acessível
    // e o texto volta a ser selecionável/copiável normalmente.
    const [messageMenuAnchor, setMessageMenuAnchor] = useState(null);
    const [longPressMessage, setLongPressMessage] = useState(null);
    const [replyToMessage, setReplyToMessage] = useState(null);

    // Contato (vCard) recebido numa mensagem - "Salvar contato" reaproveita
    // o mesmo diálogo de "Nova conversa" (`NovaConversaDialog`), só que
    // pré-preenchido com nome/telefone extraídos do vCard.
    const [contatoParaSalvar, setContatoParaSalvar] = useState(null);

    const [forwardDialogOpen, setForwardDialogOpen] = useState(false);
    const [forwardingMessage, setForwardingMessage] = useState(null);
    const [forwardConversations, setForwardConversations] = useState([]);
    const [forwardLoadingConversations, setForwardLoadingConversations] = useState(false);
    const [forwardSearch, setForwardSearch] = useState('');
    const [forwardSelectedIds, setForwardSelectedIds] = useState(new Set());
    const [forwardSending, setForwardSending] = useState(false);
    const [forwardError, setForwardError] = useState('');

    // "Enviar contato" (menu do clipe) - reaproveita a MESMA listagem de
    // conversas já usada pelo "Encaminhar" (`forwardConversations`/
    // `loadForwardConversations`), só que pra escolher UMA (não várias)
    // como origem do nome/telefone a compartilhar na conversa atual.
    const [contactPickerOpen, setContactPickerOpen] = useState(false);
    const [contactPickerSearch, setContactPickerSearch] = useState('');
    const [sendingContactId, setSendingContactId] = useState(null);
    const [contactPickerError, setContactPickerError] = useState('');
    // Cadastro manual - quando o cliente que o atendente quer compartilhar
    // não tem nenhuma conversa existente no CRM (ex: um contato pessoal,
    // nunca falou com a empresa). `manualPhone` já fica formatado
    // (`formatPhoneBR`, mesmo input da tela "Nova conversa") - o backend
    // (`conversation_send_contact`) tira a formatação sozinho antes de
    // mandar pro provedor.
    const [contactPickerManualMode, setContactPickerManualMode] = useState(false);
    const [manualContactName, setManualContactName] = useState('');
    const [manualContactPhone, setManualContactPhone] = useState('+55 (');

    const [showTemplatePicker, setShowTemplatePicker] = useState(false);
    const [templatesAprovados, setTemplatesAprovados] = useState([]);
    const [templateSelecionadoId, setTemplateSelecionadoId] = useState('');
    const [templateHeaderVar, setTemplateHeaderVar] = useState('');
    const [templateBodyVars, setTemplateBodyVars] = useState([]);
    const [templateMetaComponentsByKey, setTemplateMetaComponentsByKey] = useState({});

    const [showListsDialog, setShowListsDialog] = useState(false);
    const [availableLists, setAvailableLists] = useState([]);
    const [conversationListIds, setConversationListIds] = useState([]);
    const [newListNameInline, setNewListNameInline] = useState('');

    const [status, setStatus] = useState({ type: '', message: '' });

    const [inputMessage, setInputMessage] = useState('');

    const [solicitouDadosConversa, setSolicitouDadosConversa] = useState(false);

    // const [deals, setDeal] = useState(deal || {});
    const [dealNew, setDealNew] = useState(deal || {});
    const [stages, setStages] = useState([]);

    //? Default
    const [pipelineIdDefault, setPipelineIdDefault] = useState(null);
    const [stageIdDefault, setStageIdDefault] = useState(null);
    const [integrationId, setIntegrationId] = useState(null);

    //? Order
    const [tab, setTab] = useState(0);
    const [orderExists, setOrderExists] = useState(false);
    const [openProductModal, setOpenProductModal] = useState(false);
    const [products, setProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [selectedVariacao, setSelectedVariacao] = useState(null);
    const [quantity, setQuantity] = useState(1);

    //? Media
    // `getPrivateMediaUrl`/`getPrivateMediaDownloadUrl` e
    // `formatConversationTimestamp` agora são funções de escopo de módulo
    // (ver topo do arquivo, perto de `MessageList`) - usadas aqui só uma
    // vez (header de template) e dentro de `MessageList`.

    const fileInputRef = useRef(null);
    const mediaRecorderRef = useRef(null);
    const recordedChunksRef = useRef([]);
    const discardRecordingRef = useRef(false);
    const recordingTimerRef = useRef(null);
    const [isRecording, setIsRecording] = useState(false);
    const [recordingSeconds, setRecordingSeconds] = useState(0);
    // Áudio já gravado, aguardando o usuário decidir entre ouvir de novo,
    // mandar ou descartar - igual o WhatsApp Web faz, em vez de mandar
    // direto assim que a gravação para.
    const [recordedAudio, setRecordedAudio] = useState(null); // { file, url }
    // Arquivo(s) escolhido(s) no seletor do computador, aguardando
    // confirmação - mesma lógica: mostra uma prévia antes de mandar de
    // verdade. Suporta vários arquivos de uma vez (igual WhatsApp Web):
    // cada item é enviado como uma mensagem separada, na ordem escolhida.
    const [pendingAttachments, setPendingAttachments] = useState([]); // [{ file, previewUrl, kind }]
    const [activeAttachmentIndex, setActiveAttachmentIndex] = useState(0);

    // Arrastar e soltar um arquivo direto na janela da conversa - some
    // funcionalidade adicional por cima do botão de anexo/colar que já
    // existia, reaproveitando o MESMO fluxo de prévia+confirmação
    // (`abrirPreviaDeArquivoColado`, usado hoje por Ctrl+V/"Colar" do
    // menu de clique direito).
    const [isDraggingFile, setIsDraggingFile] = useState(false);
    const dragCounterRef = useRef(0); // conta enter/leave aninhados (a janela tem vários filhos) - sem isso, o mouse passando por cima de um filho interno já escondia a borda antes de sair de fato da janela.

    // Menu de clique-direito no input de mensagem, com a opção "Colar" -
    // igual o WhatsApp Web, além do Ctrl+V direto (`handleInputPaste`).
    const [inputContextMenu, setInputContextMenu] = useState(null); // { mouseX, mouseY }

    //? SCROOL
    const [isAtBottom, setIsAtBottom] = useState(true);
    const chatEndRef = useRef(null);
    const containerRef = useRef(null);
    const isUserAtBottom = () => {
        const container = containerRef.current;
        if (!container) return true;

        const threshold = 80;

        return container.scrollHeight - container.scrollTop - container.clientHeight < threshold;
    };

    const handleScroll = () => {
        setIsAtBottom(isUserAtBottom());
    };

    // `useCallback` com deps vazias - só usa `containerRef` (ref, nunca
    // muda de identidade), vira PROP estável de `MessageList` (memoizado).
    const scrollToBottom = useCallback((behavior = 'auto') => {
        const container = containerRef.current;

        if (!container) return;

        container.scrollTo({
            top: container.scrollHeight,
            behavior
        });
    }, []);

    // O container de mensagens só existe no DOM depois que uma conversa é
    // selecionada (o Drawer/Modal do MUI só monta o conteúdo real num ciclo
    // de render posterior à mudança de `conversa_selecionada`). Um useEffect
    // com `[conversa_selecionada]` nas deps rodava ANTES desse mount e nunca
    // era re-executado depois, então o listener de scroll nunca era
    // anexado de verdade — `isAtBottom` ficava travado em `true` pra sempre
    // e qualquer atualização de mensagens (polling) forçava a rolagem pro
    // fim, mesmo com o usuário lendo mensagens antigas. Uma callback ref
    // resolve isso de vez: o React a chama exatamente no momento em que o
    // nó realmente é inserido/removido do DOM, não em um ciclo de efeito
    // separado e potencialmente atrasado.
    const setContainerRef = useCallback((node) => {
        if (containerRef.current) {
            containerRef.current.removeEventListener('scroll', handleScroll);
        }
        containerRef.current = node;
        if (node) {
            node.addEventListener('scroll', handleScroll);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isAtBottom) {
            scrollToBottom('smooth');
        }
    }, [mensagens]);

    useEffect(() => {
        setIsAtBottom(true);
        scrollToBottom();
    }, [conversa_selecionada]);

    // Busca sempre os dados completos e atualizados da conversa assim que
    // ela é aberta (telefone, status da janela de 24h, responsável ativo
    // etc.) - a tela que abriu o chat pode ter passado um objeto
    // incompleto ou desatualizado (ex: a lista de Negócios usa um
    // serializer mais enxuto, sem telefone nem status da janela de 24h),
    // e sem essa busca essa tela ficava sem mostrar o telefone/aviso de
    // janela fechada mesmo quando o backend já tinha esses dados.
    useEffect(() => {
        if (!appId || !conversa_selecionada?.id) return;

        let cancelado = false;
        (async () => {
            try {
                const response = await api.get(`v1/apps/${appId}/conversations/${conversa_selecionada.id}/`);
                if (!cancelado) {
                    onConversationUpdate?.(response.data.conversation);
                }
            } catch (error) {
                console.error('Erro ao buscar dados completos da conversa ao abrir:', error);
            }
        })();

        return () => {
            cancelado = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appId, conversa_selecionada?.id]);

    useEffect(() => {
        if (!isAtBottom) return;
        const timeout = setTimeout(() => {
            scrollToBottom();
        }, 50);

        return () => clearTimeout(timeout);
    }, [mensagens.length]);

    useEffect(() => {
        if (isAtBottom && chatEndRef.current) {
            chatEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [mensagens, isAtBottom]);

    const [order, setOrder] = useState(null);

    const [form, setForm] = useState({
        title: 'Novo Negócio',
        value: 0,
        description: '',
        stage: '',
        user: '',
        organization: '',
        conversation: '',
        assign: ''
    });
    const [negocio, setNegocio] = useState({});

    useEffect(() => {
        setStatus({
            type: '',
            message: ''
        });
    }, [status_drawer]);

    const fetchDeal = async () => {
        if (!deal?.id) return;
        if (!appId) return;
        if (!pipelineId) return;

        const res = await api.get(`v1/apps/${appId}/pipelines/${pipelineId}/deals/${deal.id}/`);

        setNegocio(res.data.deal);
    };

    const getDefaultIdPipeline = async () => {
        if (!appId) return;
        try {
            const response = await api.get(`v1/apps/${appId}/pipelines/?default=true`);
            if (response.data && response.data.length > 0) {
                // console.log(`Default Pipeline: ${JSON.stringify(response.data[0])}`);
                setPipelineIdDefault(response.data[0].id);
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getDefaultIdPipeline();
    }, []);

    const getDefaultIdStage = async () => {
        if (!appId) return;
        try {
            const response = await api.get(`v1/apps/${appId}/pipelines/${pipelineId}/stages/?default=true`);
            if (response.data && response.data.length > 0) {
                console.log(`Default Stage: ${JSON.stringify(response.data[0])}`);
                setStageIdDefault(response.data[0].id);
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getDefaultIdStage();
    }, []);

    const handlerDadosConversa = () => {
        // if (!deal) return;
        setSolicitouDadosConversa((prev) => !prev);
        setStatus({ type: '', message: '' });
    };

    // No Web App instalado, o painel de negócio abre quase em tela cheia -
    // não faz sentido dividir com o chat nesse caso, então esconde a coluna
    // do chat em vez de espremer as duas lado a lado.
    const tamanhoTelaConversa = solicitouDadosConversa ? '60%' : '100%';
    const mostrarColunaChat = !(isStandalone && solicitouDadosConversa);
    const [ordersState, setOrdersState] = useState([]);

    useEffect(() => {
        if (deal?.orders) {
            setOrdersState(deal.orders);
        }
    }, [deal]);

    useEffect(() => {
        if (negocio?.orders) {
            setOrdersState(negocio.orders);
        }
    }, [negocio]);

    //? TEMA DO INPUT MENSAGEM
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';

    const enviar_arquivo = async (file, labelSuffix = '') => {
        setUploadError('');
        setUploadFileName(file.name + labelSuffix);
        setUploadProgress(0);
        setUploadingFile(true);

        try {
            const formData = new FormData();
            formData.append('file', file);
            formData.append(
                'author',
                JSON.stringify({
                    userId: '',
                    avatarUrl: '',
                    displayName: 'Nome Atendente',
                    type: 'agent'
                })
            );
            formData.append(
                'source',
                JSON.stringify({
                    originalMessageId: '',
                    originalMessageTimestamp: '',
                    type: 'file'
                })
            );
            await api.post(`v1/apps/${appId}/conversations/${conversa_selecionada.id}/messages/`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
                onUploadProgress: (progressEvent) => {
                    if (!progressEvent.total) return;
                    setUploadProgress(Math.round((progressEvent.loaded / progressEvent.total) * 100));
                }
            });
        } catch (error) {
            console.error('enviar_arquivo error:', error);
            setUploadError(error.response?.data?.error || 'Erro ao enviar o arquivo. Tente novamente.');
        } finally {
            setUploadingFile(false);
        }
    };

    // Tipo de preview a mostrar antes de confirmar o envio - igual o
    // WhatsApp Web faz: imagem/vídeo/áudio dá pra visualizar, o resto vira
    // um ícone genérico de arquivo.
    const attachmentKindFromFile = (file) => {
        if (file.type.startsWith('image/')) return 'image';
        if (file.type.startsWith('video/')) return 'video';
        if (file.type.startsWith('audio/')) return 'audio';
        return 'other';
    };

    const formatFileSize = (bytes) => {
        if (!bytes) return '';
        if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
        return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
    };

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files || []);
        e.target.value = '';
        if (files.length === 0) return;

        const novosAnexos = files.map((file) => ({
            file,
            previewUrl: URL.createObjectURL(file),
            kind: attachmentKindFromFile(file)
        }));
        // Se o seletor foi aberto pelo botão "+" da prévia, soma aos arquivos
        // já escolhidos em vez de substituir.
        setPendingAttachments((prev) => [...prev, ...novosAnexos]);
    };

    const handleCancelAttachment = () => {
        pendingAttachments.forEach((anexo) => URL.revokeObjectURL(anexo.previewUrl));
        setPendingAttachments([]);
        setActiveAttachmentIndex(0);
    };

    const handleRemovePendingAttachment = (index) => {
        setPendingAttachments((prev) => {
            const removido = prev[index];
            if (removido) URL.revokeObjectURL(removido.previewUrl);
            return prev.filter((_, i) => i !== index);
        });
        setActiveAttachmentIndex((prev) => (index <= prev ? Math.max(0, prev - 1) : prev));
    };

    const handleConfirmAttachment = async () => {
        if (pendingAttachments.length === 0) return;
        const anexos = pendingAttachments;
        setPendingAttachments([]);
        setActiveAttachmentIndex(0);

        // Cada arquivo vira uma mensagem separada, enviada em sequência (na
        // ordem escolhida) - igual o WhatsApp Web faz ao mandar várias fotos.
        for (let i = 0; i < anexos.length; i++) {
            const anexo = anexos[i];
            await enviar_arquivo(anexo.file, anexos.length > 1 ? ` (${i + 1}/${anexos.length})` : '');
            URL.revokeObjectURL(anexo.previewUrl);
        }
    };

    // Mesmo fluxo de prévia+confirmação de `handleFileChange` - usado tanto
    // pelo Ctrl+V quanto pelo "Colar" do menu de clique-direito.
    const abrirPreviaDeArquivoColado = (file) => {
        setPendingAttachments((prev) => [
            ...prev,
            {
                file,
                previewUrl: URL.createObjectURL(file),
                kind: attachmentKindFromFile(file)
            }
        ]);
    };

    // Arrastar e soltar - `dragover` PRECISA de `preventDefault` pra sequer
    // permitir o drop (senão o navegador mostra o cursor de "proibido" e
    // ignora); só faz isso quando o que está sendo arrastado é de fato um
    // arquivo (`dataTransfer.types` tem "Files") - arrastando texto
    // selecionado, por exemplo, continua caindo no comportamento padrão
    // do navegador, sem a borda/overlay de "solte aqui" aparecer à toa.
    const handleDragEnter = (e) => {
        if (!conversa_selecionada || !e.dataTransfer?.types?.includes('Files')) return;
        e.preventDefault();
        dragCounterRef.current += 1;
        setIsDraggingFile(true);
    };

    const handleDragOver = (e) => {
        if (conversa_selecionada && e.dataTransfer?.types?.includes('Files')) e.preventDefault();
    };

    const handleDragLeave = (e) => {
        if (!conversa_selecionada || !e.dataTransfer?.types?.includes('Files')) return;
        e.preventDefault();
        dragCounterRef.current = Math.max(0, dragCounterRef.current - 1);
        if (dragCounterRef.current === 0) setIsDraggingFile(false);
    };

    const handleDropFile = (e) => {
        dragCounterRef.current = 0;
        setIsDraggingFile(false);
        if (!conversa_selecionada) return;
        const files = Array.from(e.dataTransfer?.files || []);
        if (files.length === 0) return; // não era arquivo (ex: texto arrastado) - deixa o navegador decidir o que fazer
        e.preventDefault();
        files.forEach(abrirPreviaDeArquivoColado);
    };

    // Ctrl+V (ou Cmd+V) com o input focado - se o clipboard tiver um
    // arquivo/imagem (copiado do explorador, print screen, etc), manda pro
    // fluxo de anexo em vez de deixar o navegador tentar colar como texto.
    // Sem arquivo nenhum no clipboard, não faz nada especial (texto normal
    // continua colando do jeito padrão do navegador).
    const handleInputPaste = (e) => {
        const items = e.clipboardData?.items || [];
        for (const item of items) {
            if (item.kind === 'file') {
                const file = item.getAsFile();
                if (file) {
                    e.preventDefault();
                    abrirPreviaDeArquivoColado(file);
                    return;
                }
            }
        }
    };

    const handleInputContextMenu = (e) => {
        e.preventDefault();
        setInputContextMenu({ mouseX: e.clientX - 2, mouseY: e.clientY - 4 });
    };

    const closeInputContextMenu = () => setInputContextMenu(null);

    // "Colar" pelo menu de clique-direito - mesmo resultado do Ctrl+V, só
    // que sem depender do evento nativo de paste (pra quem não conhece o
    // atalho). Usa a Clipboard API assíncrona (só funciona em contexto
    // seguro - https/localhost - e pode pedir permissão na primeira vez);
    // se o navegador não suportar ou a permissão for negada, avisa e
    // sugere o atalho de teclado em vez de travar.
    const handlePasteFromContextMenu = async () => {
        closeInputContextMenu();
        try {
            const clipboardItems = await navigator.clipboard.read();
            for (const clipboardItem of clipboardItems) {
                const imageType = clipboardItem.types.find((t) => t.startsWith('image/'));
                if (imageType) {
                    const blob = await clipboardItem.getType(imageType);
                    const extensao = imageType.split('/')[1] || 'png';
                    abrirPreviaDeArquivoColado(new File([blob], `imagem-colada.${extensao}`, { type: imageType }));
                    return;
                }
            }
            const texto = await navigator.clipboard.readText();
            if (texto) setInputMessage((prev) => prev + texto);
        } catch (error) {
            console.error('handlePasteFromContextMenu error:', error);
            setStatus({ type: 'error', message: 'Não foi possível colar automaticamente. Use Ctrl+V.' });
        }
    };

    const openAttachMenu = (e) => setAttachMenuAnchor(e.currentTarget);
    const closeAttachMenu = () => setAttachMenuAnchor(null);

    const handleChooseFileFromComputer = () => {
        closeAttachMenu();
        fileInputRef.current?.click();
    };

    const loadDocumentFolders = async () => {
        const res = await api.get(`v1/apps/${appId}/document_folders/`);
        setDocumentFolders(res.data.folders || []);
    };

    const loadDocumentPickerDocuments = async (folderId) => {
        setDocumentPickerLoading(true);
        try {
            const query = folderId ? `?folder_id=${folderId}` : '';
            const res = await api.get(`v1/apps/${appId}/documents/${query}`);
            setDocumentPickerDocuments(res.data.documents || []);
        } finally {
            setDocumentPickerLoading(false);
        }
    };

    const openDocumentPicker = () => {
        closeAttachMenu();
        setDocumentPickerFolderId(null);
        setDocumentPickerOpen(true);
        loadDocumentFolders();
        loadDocumentPickerDocuments(null);
    };

    const handleSelectDocumentFolder = (folderId) => {
        setDocumentPickerFolderId(folderId);
        loadDocumentPickerDocuments(folderId);
    };

    // Envia um documento já cadastrado na biblioteca de Documentos - sem
    // FormData/bytes do cliente, o backend busca o arquivo direto do R2,
    // então isso é bem mais rápido que o upload normal de arquivo.
    const enviar_documento_existente = async (document) => {
        setDocumentPickerOpen(false);
        setUploadError('');
        setUploadFileName(document.name);
        setUploadingFile(true);

        try {
            await api.post(`v1/apps/${appId}/conversations/${conversa_selecionada.id}/messages/`, {
                document_id: document.id,
                author: {
                    userId: '',
                    avatarUrl: '',
                    displayName: 'Nome Atendente',
                    type: 'agent'
                },
                source: {
                    originalMessageId: '',
                    originalMessageTimestamp: '',
                    type: 'file'
                }
            });
        } catch (error) {
            console.error('enviar_documento_existente error:', error);
            setUploadError(error.response?.data?.error || 'Erro ao enviar o documento. Tente novamente.');
        } finally {
            setUploadingFile(false);
        }
    };

    // `useCallback` com deps vazias - só usa setters de estado (sempre
    // estáveis), vira PROP estável de `MessageList` (memoizado).
    const handleOpenMessageMenu = useCallback(
        (msg) => (e) => {
            e.stopPropagation();
            setMessageMenuAnchor(e.currentTarget);
            setLongPressMessage(msg);
        },
        []
    );

    const loadForwardConversations = async () => {
        setForwardLoadingConversations(true);
        try {
            const res = await api.get(`v1/apps/${appId}/conversations/`);
            const all = res.data.conversations || [];
            setForwardConversations(all.filter((c) => c.id !== conversa_selecionada?.id));
        } catch (error) {
            console.error('Erro ao carregar conversas pra encaminhar', error);
            setForwardConversations([]);
        } finally {
            setForwardLoadingConversations(false);
        }
    };

    const handleOpenForwardDialog = () => {
        setMessageMenuAnchor(null);
        setForwardingMessage(longPressMessage);
        setForwardSelectedIds(new Set());
        setForwardSearch('');
        setForwardError('');
        setForwardDialogOpen(true);
        loadForwardConversations();
    };

    const handleOpenReply = () => {
        setReplyToMessage(longPressMessage);
        setMessageMenuAnchor(null);
    };

    const handleCancelReply = () => setReplyToMessage(null);

    const toggleForwardSelection = (conversationId) => {
        setForwardSelectedIds((prev) => {
            const next = new Set(prev);
            if (next.has(conversationId)) next.delete(conversationId);
            else next.add(conversationId);
            return next;
        });
    };

    const handleConfirmForward = async () => {
        if (!forwardingMessage || forwardSelectedIds.size === 0) return;
        setForwardSending(true);
        setForwardError('');
        try {
            await Promise.all(
                Array.from(forwardSelectedIds).map((targetId) =>
                    api.post(`v1/apps/${appId}/conversations/${targetId}/messages/`, {
                        forward_message_id: forwardingMessage.id,
                        author: {
                            userId: '',
                            avatarUrl: '',
                            displayName: 'Nome Atendente',
                            type: 'agent'
                        },
                        source: {
                            originalMessageId: '',
                            originalMessageTimestamp: '',
                            type: forwardingMessage.content?.media_url ? 'file' : 'text'
                        }
                    })
                )
            );
            setForwardDialogOpen(false);
        } catch (error) {
            console.error('handleConfirmForward error:', error);
            setForwardError(error.response?.data?.error || 'Erro ao encaminhar a mensagem. Tente novamente.');
        } finally {
            setForwardSending(false);
        }
    };

    const openContactPicker = () => {
        closeAttachMenu();
        setContactPickerSearch('');
        setContactPickerError('');
        setContactPickerManualMode(false);
        setManualContactName('');
        setManualContactPhone('+55 (');
        setContactPickerOpen(true);
        loadForwardConversations();
    };

    // `conversaOrigem` tanto pode ser uma conversa existente (da lista -
    // `phone` vem de `_serialize_conversation_for_inbox`, backend) quanto
    // um objeto montado na hora a partir do cadastro manual (ver
    // `handleSendManualContact` abaixo) - mesmo formato (`displayName`/
    // `phone`) nos dois casos, então o envio em si nem precisa saber qual
    // dos dois foi usado.
    const handleSendContact = async (conversaOrigem) => {
        if (!conversa_selecionada?.id || !conversaOrigem.phone) return;
        setSendingContactId(conversaOrigem.id || 'manual');
        setContactPickerError('');
        try {
            await api.post(`v1/apps/${appId}/conversations/${conversa_selecionada.id}/send-contact/`, {
                contact_name: conversaOrigem.displayName || conversaOrigem.phone,
                contact_phone: conversaOrigem.phone
            });
            setContactPickerOpen(false);
        } catch (error) {
            console.error('handleSendContact error:', error);
            setContactPickerError(error.response?.data?.error || 'Erro ao enviar o contato. Tente novamente.');
        } finally {
            setSendingContactId(null);
        }
    };

    const handleSendManualContact = () => {
        const telefoneDigitos = manualContactPhone.replace(/\D/g, '');
        if (!manualContactName.trim() || telefoneDigitos.length < 12) return;
        handleSendContact({ displayName: manualContactName.trim(), phone: telefoneDigitos });
    };

    const handleMicClick = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            const recorder = new MediaRecorder(stream, { mimeType: 'audio/webm' });
            recordedChunksRef.current = [];
            discardRecordingRef.current = false;

            recorder.ondataavailable = (e) => {
                if (e.data.size > 0) recordedChunksRef.current.push(e.data);
            };

            recorder.onstop = () => {
                stream.getTracks().forEach((t) => t.stop());
                clearInterval(recordingTimerRef.current);
                setIsRecording(false);

                if (discardRecordingRef.current) {
                    recordedChunksRef.current = [];
                    return;
                }

                const blob = new Blob(recordedChunksRef.current, { type: 'audio/webm' });
                const file = new File([blob], `audio_${Date.now()}.webm`, { type: 'audio/webm' });
                setRecordedAudio({ file, url: URL.createObjectURL(blob) });
            };

            recorder.start();
            mediaRecorderRef.current = recorder;
            setIsRecording(true);
            setRecordingSeconds(0);
            recordingTimerRef.current = setInterval(() => {
                setRecordingSeconds((s) => s + 1);
            }, 1000);
        } catch (err) {
            console.error('Mic error:', err);
        }
    };

    // Termina a gravação e mostra o preview (ouvir/mandar/descartar) - o
    // áudio ainda NÃO é enviado aqui.
    const handleStopRecording = () => {
        discardRecordingRef.current = false;
        mediaRecorderRef.current?.stop();
    };

    // Cancela a qualquer momento: durante a gravação (para e descarta sem
    // guardar nada) ou já no preview (descarta o que já foi gravado).
    const handleCancelRecording = () => {
        if (isRecording) {
            discardRecordingRef.current = true;
            mediaRecorderRef.current?.stop();
        }
        if (recordedAudio) {
            URL.revokeObjectURL(recordedAudio.url);
            setRecordedAudio(null);
        }
    };

    const handleSendRecordedAudio = () => {
        if (!recordedAudio) return;
        enviar_arquivo(recordedAudio.file);
        URL.revokeObjectURL(recordedAudio.url);
        setRecordedAudio(null);
    };

    const formatRecordingTime = (totalSeconds) => {
        const minutes = Math.floor(totalSeconds / 60)
            .toString()
            .padStart(2, '0');
        const seconds = (totalSeconds % 60).toString().padStart(2, '0');
        return `${minutes}:${seconds}`;
    };

    // Some da tela sem terminar a gravação (troca de conversa, etc.) - evita
    // vazar o microfone ligado e o timer rodando em segundo plano.
    useEffect(() => {
        return () => {
            clearInterval(recordingTimerRef.current);
            mediaRecorderRef.current?.stream?.getTracks().forEach((t) => t.stop());
            if (recordedAudio) URL.revokeObjectURL(recordedAudio.url);
            pendingAttachments.forEach((anexo) => URL.revokeObjectURL(anexo.previewUrl));
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const enviar_mensagens_conversa = async () => {
        try {
            console.log(`enviar_mensagens_conversa: ${inputMessage}`);
            const payload = {
                author: {
                    userId: '',
                    avatarUrl: '',
                    displayName: 'Nome Atendente',
                    type: 'agent'
                },
                content: {
                    type: 'text',
                    text: inputMessage
                },
                source: {
                    integrationId: '1',
                    originalMessageId: '',
                    originalMessageTimestamp: '',
                    type: 'text'
                },
                ...(replyToMessage ? { reply_to_message_id: replyToMessage.id } : {})
            };
            const response = await api.post(`v1/apps/${appId}/conversations/${conversa_selecionada.id}/messages/`, payload);

            if (response.data) {
                setInputMessage('');
                setReplyToMessage(null);
            } else {
                setStatus({
                    type: 'error',
                    message: 'Erro ao pegar dados da conversa!'
                });
            }
        } catch (error) {
            // A janela de 24h pode ter fechado entre o carregamento da tela
            // e o clique de enviar - nesse caso, abre o seletor de template
            // em vez de só mostrar um erro genérico.
            if (error.response?.status === 409 && error.response?.data?.error === 'window_closed') {
                setStatus({ type: 'error', message: error.response.data.message });
                carregarTemplatesAprovados();
                setShowTemplatePicker(true);
                return;
            }

            console.error(error);
            setStatus({
                type: 'error',
                message: 'Erro ao pegar dados da conversa!'
            });
        }
    };

    const carregarTemplatesAprovados = async () => {
        if (!appId || !conversa_selecionada?.integration) return;
        try {
            const [localRes, metaRes] = await Promise.all([
                api.get(`v1/apps/${appId}/whatsapp_templates/`, {
                    params: { integration_id: conversa_selecionada.integration, status: 'approved' }
                }),
                // Consulta a Meta direto também - o cache local (header_text/
                // body_text salvos aqui) pode estar desatualizado em relação
                // ao que a Meta realmente aprovou (ex: template importado),
                // e mandar um header sem a variável que a Meta espera faz o
                // envio falhar. Igual já corrigido em "Templates WhatsApp" e
                // em "Criar Campanha".
                api
                    .get(`v1/apps/${appId}/integrations/${conversa_selecionada.integration}/whatsapp_templates_meta/`)
                    .catch(() => ({ data: [] }))
            ]);
            setTemplatesAprovados(localRes.data || []);

            const metaByKey = {};
            (Array.isArray(metaRes.data) ? metaRes.data : []).forEach((mt) => {
                metaByKey[`${mt.name}__${mt.language}`] = mt.components || [];
            });
            setTemplateMetaComponentsByKey(metaByKey);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if (!conversa_selecionada || conversa_selecionada.can_send_free_text !== false) return;
        carregarTemplatesAprovados();
    }, [conversa_selecionada?.id, conversa_selecionada?.can_send_free_text]);

    const templateSelecionado = templatesAprovados.find((t) => t.id === templateSelecionadoId) || null;

    // A Meta suporta variável numérica ({{1}}) e nomeada ({{nome}}) - conta
    // qualquer coisa dentro de {{...}}, não só números.
    const contarVariaveis = (texto) => (texto?.match(/\{\{[^}]+\}\}/g) || []).length;

    const getComponentText = (components, type) => components?.find((c) => c.type === type)?.text;

    // Prefere sempre o campo vindo da Meta (fonte real de verdade) - mas
    // cai pro cache local campo a campo (não a template inteira) se a Meta
    // não tiver esse componente específico. Um array de components vazio
    // ainda é "verdadeiro" em JS, então checar por componente (em vez de só
    // "existe a lista?") evita perder o fallback pro cache local à toa.
    const getTemplateDisplayFields = (t) => {
        const components = (t && templateMetaComponentsByKey[`${t.name}__${t.language}`]) || [];
        const headerComp = components.find((c) => c.type === 'HEADER');
        // A Meta não devolve a imagem do header na listagem de templates (só
        // o handle usado na criação) - a prévia/reenvio sempre usa a cópia
        // própria guardada no R2 na hora da criação (`header_image_r2_key`),
        // mesmo quando o resto veio da Meta.
        const headerFormat = headerComp?.format ?? t?.header_format ?? 'TEXT';
        return {
            headerText: getComponentText(components, 'HEADER') ?? t?.header_text,
            bodyText: getComponentText(components, 'BODY') ?? t?.body_text,
            footerText: getComponentText(components, 'FOOTER') ?? t?.footer_text,
            headerFormat,
            headerImageUrl: headerFormat === 'IMAGE' && t?.header_image_r2_key ? getPrivateMediaUrl(t.header_image_r2_key, appId) : null
        };
    };

    const escolherTemplate = (templateId) => {
        setTemplateSelecionadoId(templateId);
        const t = templatesAprovados.find((tpl) => tpl.id === templateId);
        const { bodyText } = getTemplateDisplayFields(t);
        setTemplateHeaderVar('');
        setTemplateBodyVars(new Array(contarVariaveis(bodyText)).fill(''));
    };

    const enviar_template_conversa = async () => {
        if (!templateSelecionado) return;
        try {
            const payload = {
                author: {
                    userId: '',
                    avatarUrl: '',
                    displayName: 'Nome Atendente',
                    type: 'agent'
                },
                content: {
                    type: 'whatsapp_template',
                    template_id: templateSelecionado.id,
                    header_variable: templateHeaderVar || null,
                    body_variables: templateBodyVars
                },
                source: {
                    integrationId: '1',
                    originalMessageId: '',
                    originalMessageTimestamp: '',
                    type: 'text'
                }
            };
            await api.post(`v1/apps/${appId}/conversations/${conversa_selecionada.id}/messages/`, payload);
            setShowTemplatePicker(false);
            setTemplateSelecionadoId('');
            setTemplateHeaderVar('');
            setTemplateBodyVars([]);
        } catch (error) {
            console.error(error);
            setStatus({
                type: 'error',
                message: error.response?.data?.error || 'Erro ao enviar template.'
            });
        }
    };

    // 🔹 Listas personalizadas (etiquetas, tipo Labels do WhatsApp)
    const abrirListasDialog = async () => {
        setShowListsDialog(true);
        if (!appId || !conversa_selecionada?.id) return;

        try {
            const [listsRes, conversationListsRes] = await Promise.all([
                api.get(`v1/apps/${appId}/conversation_lists/`),
                api.get(`v1/apps/${appId}/conversations/${conversa_selecionada.id}/lists/`)
            ]);
            setAvailableLists(listsRes.data || []);
            setConversationListIds((conversationListsRes.data?.list_ids || []).map(String));
        } catch (error) {
            console.error('Erro ao carregar listas', error);
        }
    };

    const toggleConversationInList = async (listId, isChecked) => {
        if (!appId || !conversa_selecionada?.id) return;
        try {
            if (isChecked) {
                await api.post(`v1/apps/${appId}/conversation_lists/${listId}/conversations/${conversa_selecionada.id}/`);
                setConversationListIds((prev) => [...prev, String(listId)]);
            } else {
                await api.delete(`v1/apps/${appId}/conversation_lists/${listId}/conversations/${conversa_selecionada.id}/`);
                setConversationListIds((prev) => prev.filter((id) => id !== String(listId)));
            }
        } catch (error) {
            console.error('Erro ao atualizar lista da conversa', error);
        }
    };

    const criarListaInlineEMarcar = async () => {
        const name = newListNameInline.trim();
        if (!name || !appId) return;
        try {
            const response = await api.post(`v1/apps/${appId}/conversation_lists/`, { name });
            const novaLista = response.data;
            setAvailableLists((prev) => [...prev, novaLista]);
            setNewListNameInline('');
            await toggleConversationInList(novaLista.id, true);
        } catch (error) {
            console.error('Erro ao criar lista', error);
        }
    };

    useEffect(() => {
        if (!conversa_selecionada) return;
        conversa_lida();
    }, []);

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            if (inputMessage.trim()) {
                enviar_mensagens_conversa();
                // enviar_mensagens_conversa_w_api();
                setInputMessage('');
            }
        }
    };

    const formatDateBR = (date) => {
        if (!date) return '';
        return new Date(date).toLocaleString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const getStages = async () => {
        if (!appId) return;
        try {
            const response = await api.get(`v1/apps/${appId}/pipelines/${pipelineId}/stages/`);
            if (response.data) {
                setStages(response.data);
            } else {
                setStatus({
                    type: 'error',
                    message: 'Erro ao buscar fases!'
                });
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getStages();
    }, [deal]);

    const createDeal = async () => {
        const payload = {
            pipeline: pipelineIdDefault,
            title: form.title,
            value: form.value,
            description: form.description,
            stage: stageIdDefault,
            user: form.user,
            organization: form.organization,
            assign: form.assign
        };

        const cleanPayload = Object.fromEntries(Object.entries(payload).filter(([_, v]) => v !== null && v !== undefined));

        console.log(`JanelaConversa - createDeal - cleanPayload: ${JSON.stringify(cleanPayload)}`);
        console.log(`JanelaConversa - createDeal - url:v1/apps/${appId}/pipelines/${pipelineId}/deals/`);

        const response = await api.post(`v1/apps/${appId}/pipelines/${pipelineId}/deals/`, cleanPayload);

        console.log(`JanelaConversa - createDeal - response:${JSON.stringify(response)}`);

        return response.data;
    };

    useEffect(() => {
        if (!appId) return;

        const interval = setInterval(() => {
            fetchDeal();
        }, 3000);

        return () => clearInterval(interval);
    }, [negocio]);

    const formatCurrencyBR = (value) => {
        if (value === null || value === undefined || value === '') return '';

        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(Number(value));
    };

    const attachDealToConversation = async (dealId) => {
        return api.patch(`v1/apps/${appId}/conversations/${conversa_selecionada.id}/`, { deal: dealId });
    };

    const refreshConversationStatus = async () => {
        if (!appId || !conversa_selecionada?.id) return;
        try {
            const response = await api.get(`v1/apps/${appId}/conversations/${conversa_selecionada.id}/`);
            onConversationUpdate?.(response.data.conversation);
        } catch (error) {
            console.error('Erro ao atualizar status da conversa:', error);
        }
    };

    const handleAssumirConversa = async () => {
        // await api.post(`/v1/conversations/${conversa_selecionada.id}/assume/`);
        await api.post(`v1/apps/${appId}/conversations/${conversa_selecionada.id}/assume/`);
        await refreshConversationStatus();
    };

    const handleFinalizarConversa = async () => {
        // await api.post(`/v1/conversations/${conversa_selecionada.id}/close/`);
        await api.post(`v1/apps/${appId}/conversations/${conversa_selecionada.id}/close_conversation/`);
        await refreshConversationStatus();
    };

    const [refreshingAvatar, setRefreshingAvatar] = useState(false);

    const handleRefreshAvatar = async () => {
        if (!conversa_selecionada?.id || refreshingAvatar) return;
        setRefreshingAvatar(true);
        try {
            await api.post(`v1/apps/${appId}/conversations/${conversa_selecionada.id}/refresh_avatar/`);
            setStatus({ type: 'success', message: 'A foto será atualizada na próxima mensagem desse contato.' });
        } catch (error) {
            console.error('Erro ao forçar atualização da foto', error);
        } finally {
            setRefreshingAvatar(false);
        }
    };

    const handleVoltarParaBot = async () => {
        // A rota no backend é camelCase (igual acceptControl/offerControl),
        // não snake_case - só isso já causava 404 em todo clique.
        await api.post(`v1/apps/${appId}/conversations/${conversa_selecionada.id}/passControl/`);
        await refreshConversationStatus();
    };

    const [resumoDialogOpen, setResumoDialogOpen] = useState(false);
    const [resumoLoading, setResumoLoading] = useState(false);
    const [resumoResultado, setResumoResultado] = useState(null);
    const [resumoErro, setResumoErro] = useState('');

    const handleGerarResumo = async () => {
        if (!conversa_selecionada?.id) return;
        setResumoDialogOpen(true);
        setResumoLoading(true);
        setResumoErro('');
        setResumoResultado(null);
        try {
            const response = await api.post(`v1/apps/${appId}/conversations/${conversa_selecionada.id}/gerar-resumo/`);
            setResumoResultado(response.data);
        } catch (error) {
            setResumoErro(error?.response?.data?.error || 'Falha ao gerar o resumo dessa conversa.');
        } finally {
            setResumoLoading(false);
        }
    };

    return (
        <>
            <Drawer
                anchor="right"
                open={status_drawer}
                onClose={onCloseDrawer}
                PaperProps={{
                    sx: {
                        width: isStandalone ? '100%' : '60%',
                        height: '100%',
                        p: 0,
                        display: 'flex',
                        flexDirection: 'row',
                        backgroundColor: isDark ? '#161818' : '#efeae2',
                        overflow: 'hidden'
                    }
                }}
            >
                {/* COLUNA DIREITA — Mensagens (o SEU layout atual ajustado) */}
                <Box
                    onDragEnter={handleDragEnter}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDropFile}
                    sx={{
                        position: 'relative',
                        display: mostrarColunaChat ? 'flex' : 'none',
                        width: tamanhoTelaConversa, // chat continua com 50%
                        height: '100%',
                        flexDirection: 'column',
                        borderRight: solicitouDadosConversa ? `1px solid ${isDark ? '#2a3942' : '#ddd'}` : 'none',
                        transition: 'width 0.3s ease'
                    }}
                >
                    {isDraggingFile && (
                        <Box
                            sx={{
                                position: 'absolute',
                                inset: 0,
                                zIndex: 20,
                                pointerEvents: 'none',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                border: '3px dashed #25D366',
                                borderRadius: 1,
                                bgcolor: isDark ? 'rgba(18,44,36,0.85)' : 'rgba(220,255,235,0.90)'
                            }}
                        >
                            <Typography variant="h6" sx={{ color: '#25D366', fontWeight: 700 }}>
                                Solte o arquivo aqui para enviar
                            </Typography>
                        </Box>
                    )}
                    {conversa_selecionada ? (
                        <>
                            {/* Informações do contato */}
                            {/* HEADER */}
                            <Box
                                sx={{
                                    height: 64,
                                    px: 2,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    bgcolor: isDark ? '#202c33' : '#f0f2f5',
                                    borderBottom: `1px solid ${isDark ? '#2a3942' : '#ddd'}`,
                                    flexShrink: 0
                                }}
                            >
                                {/* ESQUERDA - Voltar (só no Web App instalado, tela cheia) + Avatar + Nome */}
                                <Box display="flex" alignItems="center" gap={1.5} minWidth={0}>
                                    {isStandalone && (
                                        <IconButton onClick={onCloseDrawer} sx={{ ml: -1, flexShrink: 0 }}>
                                            <IconArrowLeft />
                                        </IconButton>
                                    )}
                                    {/* <Avatar src={conversa_selecionada.avatarUrl} sx={{ width: 40, height: 40 }} /> */}
                                    <Box sx={{ position: 'relative' }}>
                                        {conversa_selecionada.avatarUrl !== null && <Avatar src={conversa_selecionada.avatarUrl} />}
                                        {conversa_selecionada.avatarUrl === null && (
                                            <Avatar {...stringAvatar(conversa_selecionada.displayName)} />
                                        )}
                                        <IconButton
                                            size="small"
                                            onClick={handleRefreshAvatar}
                                            disabled={refreshingAvatar}
                                            title="Forçar recarregar a foto de perfil"
                                            sx={{
                                                position: 'absolute',
                                                bottom: -6,
                                                right: -6,
                                                width: 20,
                                                height: 20,
                                                bgcolor: isDark ? '#2a3942' : '#fff',
                                                boxShadow: '0 0 0 1px rgba(0,0,0,0.15)',
                                                '&:hover': { bgcolor: isDark ? '#2a3942' : '#fff' }
                                            }}
                                        >
                                            <IconRefresh size={13} />
                                        </IconButton>
                                    </Box>

                                    <Box sx={{ minWidth: 0 }}>
                                        <Typography
                                            noWrap
                                            sx={{
                                                fontSize: '0.95rem',
                                                fontWeight: 500,
                                                color: isDark ? '#e9edef' : '#111b21'
                                            }}
                                        >
                                            {conversa_selecionada.displayName}
                                        </Typography>

                                        {conversa_selecionada.phone && (
                                            <Typography noWrap variant="caption" sx={{ color: '#667781', display: 'block' }}>
                                                {formatPhoneDisplay(conversa_selecionada.phone)}
                                            </Typography>
                                        )}

                                        {conversa_selecionada.email && (
                                            <Typography noWrap variant="caption" sx={{ color: '#667781', display: 'block' }}>
                                                {conversa_selecionada.email}
                                            </Typography>
                                        )}

                                        <Typography variant="caption" sx={{ color: '#667781' }}>
                                            Ultima atualização ás:
                                        </Typography>
                                    </Box>

                                    {/* DIREITA - BOTÕES */}
                                    <IconButton onClick={handleGerarResumo} title="Gerar resumo da conversa (IA)">
                                        <IconSparkles size={20} />
                                    </IconButton>
                                    <IconButton onClick={abrirListasDialog} title="Adicionar a uma lista">
                                        <IconTags size={20} />
                                    </IconButton>
                                </Box>

                                {/* Sem depender de `deal` de propósito - o painel também serve
                                    pra mover a conversa de equipe (`DadosDealDrawer.js`), que
                                    não tem nada a ver com negócio/pipeline. */}
                                <Button onClick={handlerDadosConversa} sx={{ minWidth: 'auto', p: 1 }} color="secondary">
                                    <IconMenu2 />
                                </Button>
                            </Box>

                            {/* TARJA CONTROLE DA CONVERSA */}
                            <Box
                                sx={{
                                    px: 2,
                                    py: 1.5,
                                    bgcolor: isDark ? '#111b21' : '#ffffff',
                                    borderBottom: `1px solid ${isDark ? '#2a3942' : '#e0e0e0'}`,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 1
                                }}
                            >
                                {/* Linha superior - Status principal */}
                                <Box display="flex" alignItems="center" justifyContent="space-between">
                                    <Box display="flex" alignItems="center" gap={1}>
                                        <Box
                                            sx={{
                                                width: 10,
                                                height: 10,
                                                borderRadius: '50%',
                                                bgcolor:
                                                    conversa_selecionada.state === 'in_bot'
                                                        ? '#42a5f5'
                                                        : conversa_selecionada.state === 'closed'
                                                          ? '#9e9e9e'
                                                          : '#4caf50'
                                            }}
                                        />

                                        <Typography sx={{ fontWeight: 600, fontSize: '0.85rem' }}>
                                            {conversa_selecionada.state === 'in_bot'
                                                ? 'Chatbot ativo'
                                                : conversa_selecionada.state === 'closed'
                                                  ? 'Conversa encerrada'
                                                  : 'Atendimento humano'}
                                        </Typography>
                                    </Box>

                                    {/* Status textual */}
                                    {conversa_selecionada.state === 'in_bot' && (
                                        <Typography fontWeight={600} sx={{ color: 'text.secondary' }}>
                                            Status Conversa: No Bot
                                        </Typography>
                                    )}
                                    {conversa_selecionada.state === 'new' && (
                                        <Typography fontWeight={600} sx={{ color: 'text.secondary' }}>
                                            Status Conversa: Novo
                                        </Typography>
                                    )}
                                    {conversa_selecionada.state === 'open' && (
                                        <Typography fontWeight={600} sx={{ color: 'text.secondary' }}>
                                            Status Conversa: Aberta
                                        </Typography>
                                    )}
                                    {conversa_selecionada.state === 'in_progress' && (
                                        <Typography fontWeight={600} sx={{ color: 'text.secondary' }}>
                                            Status Conversa: Em andamento
                                        </Typography>
                                    )}
                                    {conversa_selecionada.state === 'pending' && (
                                        <Typography fontWeight={600} sx={{ color: 'text.secondary' }}>
                                            Status Conversa: Pendente
                                        </Typography>
                                    )}
                                    {conversa_selecionada.state === 'closed' && (
                                        <Typography fontWeight={600} sx={{ color: 'text.secondary' }}>
                                            Status Conversa: Encerrada
                                        </Typography>
                                    )}
                                </Box>

                                {/* Linha inferior - Responsável + Botões */}
                                <Box display="flex" alignItems="center" justifyContent="space-between">
                                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                        Responsável:{' '}
                                        <strong>{conversa_selecionada.ActiveSwitchboardIntegration?.name || 'Não atribuído'}</strong>
                                    </Typography>

                                    <Box display="flex" gap={1}>
                                        {conversa_selecionada.state === 'in_bot' && (
                                            <Button size="small" variant="contained" color="success" onClick={handleAssumirConversa}>
                                                Assumir
                                            </Button>
                                        )}

                                        {conversa_selecionada.state !== 'in_bot' && conversa_selecionada.state !== 'closed' && (
                                            <Button size="small" variant="outlined" color="success" onClick={handleVoltarParaBot}>
                                                Voltar para Bot
                                            </Button>
                                        )}

                                        {conversa_selecionada.state !== 'closed' && (
                                            <Button size="small" variant="outlined" color="error" onClick={handleFinalizarConversa}>
                                                Finalizar
                                            </Button>
                                        )}
                                    </Box>
                                </Box>
                                {/* Dados da venda - Linha superior */}
                                <Box display="flex" alignItems="center" justifyContent="space-between">
                                    {ordersState.length === 0 && <Typography color="text.secondary">Nenhum pedido criado</Typography>}

                                    {ordersState.map((order, orderIndex) => (
                                        <Box
                                            key={order.id}
                                            sx={{
                                                borderRadius: 1,
                                                p: 1,
                                                minWidth: '100%',
                                                minHeight: 10,
                                                background: isDark ? '#1f2c33' : '#fff',
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                                            }}
                                        >
                                            <Box display="flex" justifyContent="space-between" mb={2} mt={0.3}>
                                                <Typography fontWeight={900}>Dados da Venda </Typography>
                                                {order.status === 'draft' && <Chip label="Rascunho" size="small" />}
                                                {order.status === 'pending' && (
                                                    <Chip
                                                        sx={{
                                                            background: '#D0D622',
                                                            color: '#708076',
                                                            textTransform: 'none',
                                                            fontWeight: 600
                                                        }}
                                                        label="Pendente"
                                                        size="small"
                                                    />
                                                )}
                                                {order.status === 'approved' && (
                                                    <Chip
                                                        sx={{
                                                            background: '#06731B',
                                                            color: '#D4D7D9',
                                                            textTransform: 'none',
                                                            fontWeight: 600
                                                        }}
                                                        label="Aprovado"
                                                        size="small"
                                                    />
                                                )}
                                                {order.status === 'paid' && (
                                                    <Chip
                                                        sx={{
                                                            background: '#27F550',
                                                            color: '#708076',
                                                            textTransform: 'none',
                                                            fontWeight: 600
                                                        }}
                                                        label="Pago"
                                                        size="small"
                                                    />
                                                )}
                                                {order.status === 'canceled' && (
                                                    <Chip
                                                        sx={{
                                                            background: '#D64922',
                                                            color: '#D4D7D9',
                                                            textTransform: 'none',
                                                            fontWeight: 600
                                                        }}
                                                        label="Cancelado"
                                                        size="small"
                                                    />
                                                )}
                                                {order.status === 'refunded' && (
                                                    <Chip
                                                        sx={{
                                                            background: '#2192DE',
                                                            color: '#D4D7D9',
                                                            textTransform: 'none',
                                                            fontWeight: 600
                                                        }}
                                                        label="Reembolsado"
                                                        size="small"
                                                    />
                                                )}
                                            </Box>
                                            <Box>
                                                {order?.items?.length > 0 && (
                                                    <>
                                                        <Typography mt={-1}>Quantidade de itens: {order?.items?.length}</Typography>
                                                        <Typography mt={1}>Valor total: {formatCurrencyBR(order?.total_value)}</Typography>
                                                    </>
                                                )}
                                            </Box>
                                        </Box>
                                    ))}
                                </Box>
                            </Box>

                            {/* MENSAGENS */}
                            <MessageList
                                mensagens={mensagens}
                                carregandoMensagens={carregandoMensagens}
                                isDark={isDark}
                                appId={appId}
                                conversaTipo={conversa_selecionada?.type}
                                isAtBottom={isAtBottom}
                                scrollToBottom={scrollToBottom}
                                handleOpenMessageMenu={handleOpenMessageMenu}
                                retriedMediaUrls={retriedMediaUrls}
                                retryingMediaId={retryingMediaId}
                                handleRetryMedia={handleRetryMedia}
                                setContatoParaSalvar={setContatoParaSalvar}
                                onContainerRef={setContainerRef}
                                hasMoreOlderMessages={hasMoreOlderMessages}
                                loadingOlderMessages={loadingOlderMessages}
                                onLoadOlderMessages={onLoadOlderMessages}
                            />

                            {/* CAMPO DE ENVIO */}
                            {/* INPUT FIXO */}
                            <Box
                                position="sticky"
                                bottom={0}
                                px={2}
                                py={1}
                                bgcolor={isDark ? '#202c33' : '#f0f2f5'}
                                borderTop={`1px solid ${isDark ? '#2a3942' : '#ddd'}`}
                                zIndex={10}
                            >
                                {/* EMOJI PICKER */}
                                {showEmoji && (
                                    <Box position="absolute" bottom={70} left={16} zIndex={20}>
                                        <EmojiPicker
                                            theme={isDark ? 'dark' : 'light'}
                                            onEmojiClick={(event, emojiData) => setInputMessage((prev) => prev + emojiData.emoji)}
                                        />
                                    </Box>
                                )}

                                {/* BARRA DE RESPOSTA CITADA (clicar e segurar > "Responder") */}
                                {replyToMessage && (
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            mb: 1,
                                            pl: 1.5,
                                            pr: 0.5,
                                            py: 0.5,
                                            borderRadius: '8px',
                                            borderLeft: '3px solid #06cf9c',
                                            bgcolor: isDark ? '#2a3942' : '#ffffff'
                                        }}
                                    >
                                        <Box sx={{ overflow: 'hidden' }}>
                                            <Typography variant="caption" sx={{ display: 'block', fontWeight: 600, color: '#06cf9c' }}>
                                                {replyToMessage.author?.type === 'user' ? 'Cliente' : 'Você'}
                                            </Typography>
                                            <Typography
                                                variant="caption"
                                                sx={{
                                                    display: '-webkit-box',
                                                    WebkitLineClamp: 1,
                                                    WebkitBoxOrient: 'vertical',
                                                    overflow: 'hidden',
                                                    color: isDark ? '#aebac1' : 'text.secondary'
                                                }}
                                            >
                                                {replyToMessage.content?.text || replyToMessage.content?.media_filename || 'Mensagem'}
                                            </Typography>
                                        </Box>
                                        <IconButton size="small" onClick={handleCancelReply}>
                                            <CloseIcon fontSize="small" />
                                        </IconButton>
                                    </Box>
                                )}

                                {/* JANELA DE 24H FECHADA (WhatsApp API Oficial e Instagram) */}
                                {conversa_selecionada?.can_send_free_text === false && (
                                    <Alert
                                        severity="warning"
                                        sx={{ mb: 1 }}
                                        action={
                                            conversa_selecionada?.type === 'whatsapp' ? (
                                                <Button
                                                    size="small"
                                                    onClick={() => {
                                                        carregarTemplatesAprovados();
                                                        setShowTemplatePicker(true);
                                                    }}
                                                >
                                                    Escolher Template
                                                </Button>
                                            ) : undefined
                                        }
                                    >
                                        {conversa_selecionada?.type === 'whatsapp'
                                            ? 'A janela de 24h desta conversa está fechada. Envie um Message Template aprovado para retomar o contato.'
                                            : 'A janela de 24h desta conversa está fechada. Aguarde o cliente enviar uma nova mensagem para poder responder novamente.'}
                                    </Alert>
                                )}

                                {/* PROGRESSO DE UPLOAD DE ANEXO */}
                                {uploadingFile && (
                                    <Box sx={{ mb: 1 }}>
                                        <Box display="flex" justifyContent="space-between" mb={0.5}>
                                            <Typography variant="caption" sx={{ color: isDark ? '#aebac1' : '#54656f' }}>
                                                Enviando {uploadFileName}...
                                            </Typography>
                                            <Typography variant="caption" sx={{ color: isDark ? '#aebac1' : '#54656f' }}>
                                                {uploadProgress}%
                                            </Typography>
                                        </Box>
                                        <LinearProgress variant="determinate" value={uploadProgress} sx={{ borderRadius: 4, height: 6 }} />
                                    </Box>
                                )}

                                {uploadError && (
                                    <Alert severity="error" sx={{ mb: 1 }} onClose={() => setUploadError('')}>
                                        {uploadError}
                                    </Alert>
                                )}

                                {isRecording || recordedAudio ? (
                                    <Box
                                        display="flex"
                                        alignItems="center"
                                        gap={1.5}
                                        sx={{
                                            bgcolor: isDark ? '#2a3942' : '#ffffff',
                                            borderRadius: '8px',
                                            px: 2,
                                            py: 1
                                        }}
                                    >
                                        <style>{'@keyframes recPulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.25; } }'}</style>

                                        {/* Descartar (durante a gravação ou já no preview) */}
                                        <IconButton onClick={handleCancelRecording} size="small" title="Descartar áudio">
                                            <DeleteOutlineIcon sx={{ color: '#e53935' }} />
                                        </IconButton>

                                        {isRecording ? (
                                            <>
                                                <Box
                                                    sx={{
                                                        width: 10,
                                                        height: 10,
                                                        borderRadius: '50%',
                                                        bgcolor: '#e53935',
                                                        animation: 'recPulse 1.2s ease-in-out infinite'
                                                    }}
                                                />
                                                <Typography
                                                    sx={{
                                                        flex: 1,
                                                        color: isDark ? '#e9edef' : '#111b21',
                                                        fontVariantNumeric: 'tabular-nums'
                                                    }}
                                                >
                                                    Gravando áudio... {formatRecordingTime(recordingSeconds)}
                                                </Typography>

                                                <IconButton onClick={handleStopRecording} size="small" title="Concluir gravação">
                                                    <CheckCircleIcon sx={{ color: '#25d366' }} />
                                                </IconButton>
                                            </>
                                        ) : (
                                            <>
                                                {/* Preview - ouvir antes de decidir */}
                                                <audio controls src={recordedAudio.url} style={{ flex: 1, height: 36 }} />

                                                <IconButton onClick={handleSendRecordedAudio} disabled={uploadingFile} title="Enviar áudio">
                                                    <SendIcon sx={{ color: '#54656f' }} />
                                                </IconButton>
                                            </>
                                        )}
                                    </Box>
                                ) : (
                                    <Box display="flex" alignItems="flex-end" gap={1}>
                                        {/* Emoji */}
                                        <IconButton onClick={() => setShowEmoji((v) => !v)}>
                                            <EmojiEmotionsOutlinedIcon sx={{ color: '#54656f' }} />
                                        </IconButton>

                                        {/* Anexo */}
                                        <IconButton
                                            onClick={openAttachMenu}
                                            disabled={conversa_selecionada?.can_send_free_text === false || uploadingFile}
                                        >
                                            <AttachFileIcon sx={{ color: '#54656f' }} />
                                            <input type="file" hidden multiple ref={fileInputRef} onChange={handleFileChange} />
                                        </IconButton>

                                        <Menu anchorEl={attachMenuAnchor} open={!!attachMenuAnchor} onClose={closeAttachMenu}>
                                            <MenuItem onClick={handleChooseFileFromComputer}>
                                                <ListItemIcon>
                                                    <ComputerOutlinedIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText>Arquivo do computador</ListItemText>
                                            </MenuItem>
                                            <MenuItem onClick={openDocumentPicker}>
                                                <ListItemIcon>
                                                    <FolderOpenOutlinedIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText>Documento salvo</ListItemText>
                                            </MenuItem>
                                            <MenuItem onClick={openContactPicker}>
                                                <ListItemIcon>
                                                    <PersonIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText>Contato</ListItemText>
                                            </MenuItem>
                                        </Menu>

                                        {/* Menu de clique-direito no input - "Colar" (Ctrl+V também funciona direto). */}
                                        <Menu
                                            open={inputContextMenu !== null}
                                            onClose={closeInputContextMenu}
                                            anchorReference="anchorPosition"
                                            anchorPosition={
                                                inputContextMenu !== null
                                                    ? { top: inputContextMenu.mouseY, left: inputContextMenu.mouseX }
                                                    : undefined
                                            }
                                        >
                                            <MenuItem onClick={handlePasteFromContextMenu}>
                                                <ListItemIcon>
                                                    <ContentPasteIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText>Colar</ListItemText>
                                            </MenuItem>
                                        </Menu>

                                        {/* INPUT */}
                                        <Box
                                            flex={1}
                                            sx={{
                                                bgcolor: isDark ? '#2a3942' : '#ffffff',
                                                borderRadius: '8px',
                                                px: 1.5,
                                                py: 0.5,
                                                display: 'flex',
                                                alignItems: 'center',
                                                transition: 'all 0.2s ease',
                                                maxHeight: '120px'
                                            }}
                                        >
                                            <TextField
                                                variant="standard"
                                                multiline
                                                maxRows={5}
                                                fullWidth
                                                disabled={conversa_selecionada?.can_send_free_text === false}
                                                placeholder={
                                                    conversa_selecionada?.can_send_free_text === false
                                                        ? conversa_selecionada?.type === 'whatsapp'
                                                            ? 'Envie um template pra retomar o contato'
                                                            : 'Janela de 24h fechada'
                                                        : 'Digite uma mensagem'
                                                }
                                                value={inputMessage}
                                                onChange={(e) => setInputMessage(e.target.value)}
                                                onKeyDown={handleKeyDown}
                                                onPaste={handleInputPaste}
                                                onContextMenu={handleInputContextMenu}
                                                InputProps={{
                                                    disableUnderline: true,
                                                    sx: {
                                                        fontSize: '0.95rem',
                                                        lineHeight: '1.4rem',
                                                        color: isDark ? '#e9edef' : '#111b21'
                                                    }
                                                }}
                                            />
                                        </Box>

                                        {/* SEND / MIC */}
                                        {inputMessage.trim() ? (
                                            <Fade in>
                                                <IconButton
                                                    disabled={conversa_selecionada?.can_send_free_text === false}
                                                    onClick={() => {
                                                        enviar_mensagens_conversa();
                                                        // enviar_mensagens_conversa_w_api();
                                                        setInputMessage('');
                                                    }}
                                                >
                                                    <SendIcon sx={{ color: '#54656f' }} />
                                                </IconButton>
                                            </Fade>
                                        ) : (
                                            <Fade in>
                                                <IconButton
                                                    onClick={handleMicClick}
                                                    disabled={conversa_selecionada?.can_send_free_text === false}
                                                >
                                                    <MicIcon sx={{ color: '#54656f' }} />
                                                </IconButton>
                                            </Fade>
                                        )}
                                    </Box>
                                )}
                            </Box>
                        </>
                    ) : (
                        <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                            <Typography color="textSecondary">Selecione um chat para visualizar mensagens</Typography>
                        </Box>
                    )}
                </Box>

                {/* SELETOR DE TEMPLATE (janela de 24h fechada) */}
                <Dialog open={showTemplatePicker} onClose={() => setShowTemplatePicker(false)} maxWidth="sm" fullWidth>
                    <DialogTitle>Escolher Template</DialogTitle>
                    <DialogContent>
                        {templatesAprovados.length === 0 ? (
                            <Typography color="text.secondary">Nenhum template aprovado disponível pra essa integração ainda.</Typography>
                        ) : (
                            <>
                                <TextField
                                    select
                                    fullWidth
                                    label="Template"
                                    sx={{ mt: 1, mb: 2 }}
                                    value={templateSelecionadoId}
                                    onChange={(e) => escolherTemplate(e.target.value)}
                                >
                                    {templatesAprovados.map((t) => (
                                        <MenuItem key={t.id} value={t.id}>
                                            {t.name}
                                        </MenuItem>
                                    ))}
                                </TextField>

                                {templateSelecionado && (() => {
                                    const { headerText, bodyText, footerText, headerFormat, headerImageUrl } =
                                        getTemplateDisplayFields(templateSelecionado);
                                    return (
                                    <>
                                        {headerFormat === 'IMAGE' &&
                                            (headerImageUrl ? (
                                                <Box
                                                    component="img"
                                                    src={headerImageUrl}
                                                    sx={{ width: '100%', maxHeight: 160, objectFit: 'cover', borderRadius: 1, mb: 1 }}
                                                />
                                            ) : (
                                                <Alert severity="warning" sx={{ mb: 1 }}>
                                                    Este template tem cabeçalho de imagem, mas o CRM não tem uma cópia dela salva - o
                                                    envio vai falhar. Recrie o template com a imagem.
                                                </Alert>
                                            ))}

                                        <Typography variant="body2" color="text.secondary" mb={2}>
                                            {headerFormat === 'TEXT' && headerText && <b>{headerText}</b>}
                                            <br />
                                            {bodyText}
                                            {footerText && (
                                                <>
                                                    <br />
                                                    <i>{footerText}</i>
                                                </>
                                            )}
                                        </Typography>

                                        {headerFormat === 'TEXT' && contarVariaveis(headerText) > 0 && (
                                            <TextField
                                                fullWidth
                                                sx={{ mb: 2 }}
                                                label="Variável do header"
                                                value={templateHeaderVar}
                                                onChange={(e) => setTemplateHeaderVar(e.target.value)}
                                            />
                                        )}

                                        {templateBodyVars.map((value, i) => (
                                            <TextField
                                                key={i}
                                                fullWidth
                                                sx={{ mb: 2 }}
                                                label={`Variável {{${i + 1}}}`}
                                                value={value}
                                                onChange={(e) => {
                                                    const values = [...templateBodyVars];
                                                    values[i] = e.target.value;
                                                    setTemplateBodyVars(values);
                                                }}
                                            />
                                        ))}
                                    </>
                                    );
                                })()}
                            </>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setShowTemplatePicker(false)}>Cancelar</Button>
                        <Button variant="contained" disabled={!templateSelecionado} onClick={enviar_template_conversa}>
                            Enviar
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* LISTAS PERSONALIZADAS (etiquetas) */}
                <Dialog open={showListsDialog} onClose={() => setShowListsDialog(false)} maxWidth="xs" fullWidth>
                    <DialogTitle>Listas dessa conversa</DialogTitle>
                    <DialogContent>
                        {availableLists.length === 0 ? (
                            <Typography color="text.secondary" mb={2}>
                                Nenhuma lista criada ainda.
                            </Typography>
                        ) : (
                            availableLists.map((lst) => (
                                <FormControlLabel
                                    key={lst.id}
                                    sx={{ display: 'flex' }}
                                    control={
                                        <Checkbox
                                            checked={conversationListIds.includes(String(lst.id))}
                                            onChange={(e) => toggleConversationInList(lst.id, e.target.checked)}
                                        />
                                    }
                                    label={lst.name}
                                />
                            ))
                        )}

                        <Box display="flex" gap={1} mt={2}>
                            <TextField
                                size="small"
                                fullWidth
                                placeholder="Nova lista"
                                value={newListNameInline}
                                onChange={(e) => setNewListNameInline(e.target.value)}
                            />
                            <Button variant="outlined" disabled={!newListNameInline.trim()} onClick={criarListaInlineEMarcar}>
                                Criar
                            </Button>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setShowListsDialog(false)}>Fechar</Button>
                    </DialogActions>
                </Dialog>

                {/* PRÉVIA DO(S) ARQUIVO(S) ANTES DE ENVIAR (igual WhatsApp Web) - pode
                    escolher/colar vários de uma vez; cada um vira uma mensagem. */}
                <Dialog open={pendingAttachments.length > 0} onClose={handleCancelAttachment} maxWidth="xs" fullWidth>
                    <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        {pendingAttachments.length > 1 ? `Enviar ${pendingAttachments.length} arquivos` : 'Enviar arquivo'}
                        <IconButton size="small" onClick={handleCancelAttachment}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        {pendingAttachments.length > 0 &&
                            (() => {
                                const indiceAtivo = Math.min(activeAttachmentIndex, pendingAttachments.length - 1);
                                const anexoAtivo = pendingAttachments[indiceAtivo];
                                return (
                                    <Box display="flex" flexDirection="column" alignItems="center" gap={1.5} py={1}>
                                        {anexoAtivo.kind === 'image' && (
                                            <Box
                                                component="img"
                                                src={anexoAtivo.previewUrl}
                                                alt={anexoAtivo.file.name}
                                                sx={{ maxWidth: '100%', maxHeight: 320, borderRadius: '8px', objectFit: 'contain' }}
                                            />
                                        )}

                                        {anexoAtivo.kind === 'video' && (
                                            <Box
                                                component="video"
                                                src={anexoAtivo.previewUrl}
                                                controls
                                                sx={{ maxWidth: '100%', maxHeight: 320, borderRadius: '8px' }}
                                            />
                                        )}

                                        {anexoAtivo.kind === 'audio' && (
                                            <audio controls src={anexoAtivo.previewUrl} style={{ width: '100%' }} />
                                        )}

                                        {anexoAtivo.kind === 'other' && (
                                            <Box
                                                display="flex"
                                                flexDirection="column"
                                                alignItems="center"
                                                gap={1}
                                                py={3}
                                                px={2}
                                                sx={{
                                                    width: '100%',
                                                    borderRadius: '8px',
                                                    bgcolor: isDark ? 'rgba(255,255,255,0.04)' : '#f5f6f6'
                                                }}
                                            >
                                                <DescriptionOutlinedIcon sx={{ fontSize: 48, color: '#54656f' }} />
                                            </Box>
                                        )}

                                        <Typography
                                            variant="body2"
                                            sx={{ wordBreak: 'break-word', textAlign: 'center', color: isDark ? '#e9edef' : '#111b21' }}
                                        >
                                            {anexoAtivo.file.name}
                                        </Typography>
                                        <Typography variant="caption" color="text.secondary">
                                            {formatFileSize(anexoAtivo.file.size)}
                                        </Typography>

                                        {/* Miniaturas dos arquivos escolhidos + botão "+" para adicionar mais */}
                                        <Box display="flex" gap={1} sx={{ width: '100%', overflowX: 'auto', py: 0.5 }}>
                                            {pendingAttachments.map((anexo, index) => (
                                                <Box
                                                    key={index}
                                                    onClick={() => setActiveAttachmentIndex(index)}
                                                    sx={{
                                                        position: 'relative',
                                                        flex: '0 0 auto',
                                                        width: 56,
                                                        height: 56,
                                                        borderRadius: '8px',
                                                        overflow: 'hidden',
                                                        cursor: 'pointer',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        bgcolor: isDark ? 'rgba(255,255,255,0.04)' : '#f5f6f6',
                                                        border: index === indiceAtivo ? '2px solid #25d366' : '2px solid transparent'
                                                    }}
                                                >
                                                    {anexo.kind === 'image' ? (
                                                        <Box
                                                            component="img"
                                                            src={anexo.previewUrl}
                                                            alt={anexo.file.name}
                                                            sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                        />
                                                    ) : anexo.kind === 'video' ? (
                                                        <VideocamOutlinedIcon sx={{ color: '#54656f' }} />
                                                    ) : (
                                                        <DescriptionOutlinedIcon sx={{ color: '#54656f' }} />
                                                    )}

                                                    <IconButton
                                                        size="small"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleRemovePendingAttachment(index);
                                                        }}
                                                        sx={{
                                                            position: 'absolute',
                                                            top: -4,
                                                            right: -4,
                                                            width: 20,
                                                            height: 20,
                                                            bgcolor: 'rgba(0,0,0,0.6)',
                                                            '&:hover': { bgcolor: 'rgba(0,0,0,0.8)' }
                                                        }}
                                                    >
                                                        <CloseIcon sx={{ fontSize: 14, color: '#fff' }} />
                                                    </IconButton>
                                                </Box>
                                            ))}

                                            <Box
                                                onClick={() => fileInputRef.current?.click()}
                                                sx={{
                                                    flex: '0 0 auto',
                                                    width: 56,
                                                    height: 56,
                                                    borderRadius: '8px',
                                                    cursor: 'pointer',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    bgcolor: isDark ? 'rgba(255,255,255,0.04)' : '#f5f6f6',
                                                    border: isDark ? '1px dashed rgba(255,255,255,0.2)' : '1px dashed #c7c9cb'
                                                }}
                                                title="Adicionar mais arquivos"
                                            >
                                                <AddIcon sx={{ color: '#54656f' }} />
                                            </Box>
                                        </Box>
                                    </Box>
                                );
                            })()}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCancelAttachment}>Cancelar</Button>
                        <Button variant="contained" onClick={handleConfirmAttachment} startIcon={<SendIcon />}>
                            {pendingAttachments.length > 1 ? `Enviar ${pendingAttachments.length}` : 'Enviar'}
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={documentPickerOpen} onClose={() => setDocumentPickerOpen(false)} maxWidth="xs" fullWidth>
                    <DialogTitle>Documento salvo</DialogTitle>
                    <DialogContent>
                        <Box display="flex" alignItems="center" gap={1} flexWrap="wrap" mb={2}>
                            <Chip
                                label="Todos"
                                size="small"
                                onClick={() => handleSelectDocumentFolder(null)}
                                variant={!documentPickerFolderId ? 'filled' : 'outlined'}
                            />
                            {documentFolders.map((folder) => (
                                <Chip
                                    key={folder.id}
                                    label={folder.name}
                                    size="small"
                                    onClick={() => handleSelectDocumentFolder(folder.id)}
                                    variant={documentPickerFolderId === folder.id ? 'filled' : 'outlined'}
                                    sx={{
                                        backgroundColor: documentPickerFolderId === folder.id ? folder.color || undefined : undefined,
                                        borderColor: folder.color || undefined,
                                        color: documentPickerFolderId === folder.id ? '#fff' : undefined
                                    }}
                                />
                            ))}
                        </Box>

                        {documentPickerLoading && (
                            <Box display="flex" justifyContent="center" py={2}>
                                <CircularProgress size={24} />
                            </Box>
                        )}

                        {!documentPickerLoading && documentPickerDocuments.length === 0 && (
                            <Typography variant="body2" color="text.secondary">
                                Nenhum documento cadastrado{documentPickerFolderId ? ' nessa pasta' : ''}.
                            </Typography>
                        )}

                        {!documentPickerLoading && documentPickerDocuments.length > 0 && (
                            <List dense>
                                {documentPickerDocuments.map((document) => (
                                    <ListItemButton key={document.id} onClick={() => enviar_documento_existente(document)}>
                                        <ListItemIcon>
                                            <DescriptionOutlinedIcon />
                                        </ListItemIcon>
                                        <ListItemText primary={document.name} />
                                    </ListItemButton>
                                ))}
                            </List>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setDocumentPickerOpen(false)}>Cancelar</Button>
                    </DialogActions>
                </Dialog>

                {/* Menu "clique e segure" numa mensagem */}
                <Menu anchorEl={messageMenuAnchor} open={!!messageMenuAnchor} onClose={() => setMessageMenuAnchor(null)}>
                    <MenuItem onClick={handleOpenReply}>
                        <ListItemIcon>
                            <ReplyIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Responder</ListItemText>
                    </MenuItem>
                    <MenuItem onClick={handleOpenForwardDialog}>
                        <ListItemIcon>
                            <ForwardIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Encaminhar</ListItemText>
                    </MenuItem>
                </Menu>

                {/* Dialog de seleção de conversas de destino pra encaminhar */}
                <Dialog open={forwardDialogOpen} onClose={() => setForwardDialogOpen(false)} maxWidth="xs" fullWidth>
                    <DialogTitle>Encaminhar mensagem</DialogTitle>
                    <DialogContent>
                        {forwardError && (
                            <Alert severity="error" sx={{ mb: 2 }}>
                                {forwardError}
                            </Alert>
                        )}

                        <TextField
                            fullWidth
                            size="small"
                            placeholder="Buscar conversa..."
                            value={forwardSearch}
                            onChange={(e) => setForwardSearch(e.target.value)}
                            sx={{ mb: 2 }}
                        />

                        {forwardLoadingConversations ? (
                            <Box display="flex" justifyContent="center" py={2}>
                                <CircularProgress size={24} />
                            </Box>
                        ) : (
                            <List dense sx={{ maxHeight: 320, overflow: 'auto' }}>
                                {forwardConversations
                                    .filter((c) => {
                                        const term = forwardSearch.toLowerCase();
                                        return (
                                            (c.displayName || '').toLowerCase().includes(term) ||
                                            (c.phone || '').includes(forwardSearch)
                                        );
                                    })
                                    .map((c) => (
                                        <ListItemButton key={c.id} onClick={() => toggleForwardSelection(c.id)}>
                                            <Checkbox edge="start" checked={forwardSelectedIds.has(c.id)} tabIndex={-1} disableRipple />
                                            <ListItemText primary={c.displayName || c.phone} secondary={c.phone} />
                                        </ListItemButton>
                                    ))}
                                {forwardConversations.length === 0 && (
                                    <Typography variant="body2" color="text.secondary" sx={{ px: 2 }}>
                                        Nenhuma conversa encontrada.
                                    </Typography>
                                )}
                            </List>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setForwardDialogOpen(false)}>Cancelar</Button>
                        <Button
                            variant="contained"
                            disabled={forwardSelectedIds.size === 0 || forwardSending}
                            onClick={handleConfirmForward}
                            startIcon={forwardSending ? <CircularProgress size={16} color="inherit" /> : null}
                        >
                            Encaminhar{forwardSelectedIds.size > 0 ? ` (${forwardSelectedIds.size})` : ''}
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Dialog de seleção de um cliente já cadastrado pra
                    compartilhar o contato dele (nome/telefone) na conversa
                    atual - "Enviar contato" (menu do clipe). */}
                <Dialog open={contactPickerOpen} onClose={() => setContactPickerOpen(false)} maxWidth="xs" fullWidth>
                    <DialogTitle>Enviar contato</DialogTitle>
                    <DialogContent>
                        {contactPickerError && (
                            <Alert severity="error" sx={{ mb: 2 }}>
                                {contactPickerError}
                            </Alert>
                        )}

                        {!contactPickerManualMode ? (
                            <>
                                <TextField
                                    fullWidth
                                    size="small"
                                    placeholder="Buscar cliente..."
                                    value={contactPickerSearch}
                                    onChange={(e) => setContactPickerSearch(e.target.value)}
                                    sx={{ mb: 2 }}
                                />

                                {forwardLoadingConversations ? (
                                    <Box display="flex" justifyContent="center" py={2}>
                                        <CircularProgress size={24} />
                                    </Box>
                                ) : (
                                    <List dense sx={{ maxHeight: 320, overflow: 'auto' }}>
                                        {forwardConversations
                                            .filter((c) => c.phone)
                                            .filter((c) => {
                                                const term = contactPickerSearch.toLowerCase();
                                                return (
                                                    (c.displayName || '').toLowerCase().includes(term) ||
                                                    (c.phone || '').includes(contactPickerSearch)
                                                );
                                            })
                                            .map((c) => (
                                                <ListItemButton
                                                    key={c.id}
                                                    onClick={() => handleSendContact(c)}
                                                    disabled={sendingContactId === c.id}
                                                >
                                                    <ListItemText primary={c.displayName || c.phone} secondary={c.phone} />
                                                    {sendingContactId === c.id && <CircularProgress size={18} />}
                                                </ListItemButton>
                                            ))}
                                        {forwardConversations.filter((c) => c.phone).length === 0 && (
                                            <Typography variant="body2" color="text.secondary" sx={{ px: 2 }}>
                                                Nenhum cliente encontrado.
                                            </Typography>
                                        )}
                                    </List>
                                )}

                                <Button
                                    size="small"
                                    sx={{ mt: 1 }}
                                    onClick={() => {
                                        setContactPickerError('');
                                        setContactPickerManualMode(true);
                                    }}
                                >
                                    Não encontrou? Cadastrar manualmente
                                </Button>
                            </>
                        ) : (
                            <>
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="Nome"
                                    value={manualContactName}
                                    onChange={(e) => setManualContactName(e.target.value)}
                                    sx={{ mb: 2 }}
                                />
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="Telefone"
                                    value={manualContactPhone}
                                    onChange={(e) => setManualContactPhone(formatPhoneBR(e.target.value))}
                                    sx={{ mb: 1 }}
                                />
                                <Button size="small" onClick={() => setContactPickerManualMode(false)}>
                                    Voltar pra busca
                                </Button>
                            </>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setContactPickerOpen(false)}>Cancelar</Button>
                        {contactPickerManualMode && (
                            <Button
                                variant="contained"
                                disabled={!manualContactName.trim() || manualContactPhone.replace(/\D/g, '').length < 12 || !!sendingContactId}
                                onClick={handleSendManualContact}
                            >
                                {sendingContactId ? <CircularProgress size={18} /> : 'Enviar'}
                            </Button>
                        )}
                    </DialogActions>
                </Dialog>

                {/* "Salvar contato" de uma mensagem tipo contact - mesmo
                    diálogo de "Nova conversa", pré-preenchido. */}
                <NovaConversaDialog
                    open={!!contatoParaSalvar}
                    onClose={() => setContatoParaSalvar(null)}
                    appId={appId}
                    initialNome={contatoParaSalvar?.nome}
                    initialTelefone={contatoParaSalvar?.telefone}
                    onCreated={() => setStatus({ type: 'success', message: 'Contato salvo como nova conversa!' })}
                />

                {/* Resultado do "Gerar resumo" (IA) - classificação venda/
                    interesse/sem_interesse + datas de compra + resumo em
                    texto, ver `conversas/resumo_ia.py`. */}
                <Dialog open={resumoDialogOpen} onClose={() => setResumoDialogOpen(false)} maxWidth="sm" fullWidth>
                    <DialogTitle>Resumo da conversa (IA)</DialogTitle>
                    <DialogContent>
                        {resumoLoading && (
                            <Box display="flex" justifyContent="center" py={4}>
                                <CircularProgress size={28} />
                            </Box>
                        )}
                        {!resumoLoading && resumoErro && <Alert severity="error">{resumoErro}</Alert>}
                        {!resumoLoading && resumoResultado && (
                            <Box>
                                <Chip
                                    label={
                                        { venda: 'Venda', interesse: 'Interesse', sem_interesse: 'Sem interesse' }[
                                            resumoResultado.resultado
                                        ] || resumoResultado.resultado
                                    }
                                    color={
                                        { venda: 'success', interesse: 'warning', sem_interesse: 'default' }[resumoResultado.resultado] ||
                                        'default'
                                    }
                                    sx={{ mb: 2 }}
                                />
                                <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                                    {resumoResultado.resumo || '(sem resumo)'}
                                </Typography>
                                {resumoResultado.datas_compra?.length > 0 && (
                                    <Box mt={2}>
                                        <Typography variant="caption" color="text.secondary">
                                            Datas de compra identificadas:
                                        </Typography>
                                        <Typography variant="body2">{resumoResultado.datas_compra.join(', ')}</Typography>
                                    </Box>
                                )}
                            </Box>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setResumoDialogOpen(false)}>Fechar</Button>
                    </DialogActions>
                </Dialog>

                {solicitouDadosConversa && (
                    <>
                        <Box
                            sx={{
                                width: isStandalone ? '90%' : '50%',
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                borderLeft: `1px solid ${isDark ? '#2a3942' : '#ddd'}`,
                                backgroundColor: 'DADADC', // isDark ? '#0b141a' : '#ffffff',
                                transition: 'width 0.3s ease'
                            }}
                        >
                            {solicitouDadosConversa && (
                                <DadosDeal
                                    status_drawer={status_drawer}
                                    onCloseDrawer={onCloseDrawer}
                                    onVoltarParaChat={isStandalone ? handlerDadosConversa : null}
                                    conversa_selecionada={conversa_selecionada}
                                    mensagens={mensagens}
                                    appId={appId}
                                    conversa_lida={conversa_lida}
                                    deal={deal}
                                    onDealChange={onDealChange}
                                    onDealsChanged={onDealsChanged}
                                    pipelineId={pipelineId}
                                    integration_id={integration_id}
                                />
                            )}
                        </Box>
                    </>
                )}
            </Drawer>
        </>
    );
};

export default JanelaConversa;
